(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["AdsManager"] = factory();
	else
		root["AdsManager"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpAdsManager"];
/******/ 	window["webpackJsonpAdsManager"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		4: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"rijndael-js"}[chunkId]||chunkId) + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//static.vocento.com/vam/3.8.1/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 79);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEW_SUFFIX = exports.OLD_PREFIX = exports.AMAZON_CONFIG = exports.DEFAULT_AMAZON_LOAD_TIMEOUT = exports.AMAZON_URL = exports.DEFAULT_PREBID_LOAD_TIMEOUT = exports.PREBID_URL = exports.HEADER_BIDDING_READY = exports.GPT_URL = exports.NOMBRE_FORMATO_JSON = exports.JSON_GDP2_2 = exports.JSON_GDP2_1 = exports.JSON_GDP2_0 = exports.VAM_CSS_URL = exports.MCRYPT_KEY = exports.CAPTURADOR_WS = exports.DEFAULTS = exports.SLOT_INACTIVE = exports.SLOT_VIEWABLE = exports.SLOT_EMPTY = exports.SLOT_RENDERED = exports.POSITION_FLUID = exports.ALTOS_MINIMOS_DISPOSITIVOS = exports.TIMEOUT_POSICIONES_ESTANDAR = exports.GPT_TIMEOUT = exports.GPT_READY = exports.GPT_ID_VOCENTO = exports.EDITIONS_NAMESPACE = exports.CONFIG_NAMESPACE = exports.DEFAULT_LOG_TEMPLATE = exports.SHOW_LOGS = exports.PAYWALL_COOKIE = exports.VOCUSER_COOKIE = exports.DEFAULT_TIMEOUT = exports.PROMISES_PROPERTY = exports.NAMESPACE = undefined;

var _package = __webpack_require__(4);

var _package2 = _interopRequireDefault(_package);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAMESPACE = exports.NAMESPACE = 'vocento';
var PROMISES_PROPERTY = exports.PROMISES_PROPERTY = '__PROMISES__';
var DEFAULT_TIMEOUT = exports.DEFAULT_TIMEOUT = 2000;
var VOCUSER_COOKIE = exports.VOCUSER_COOKIE = 'voc_uid';
var PAYWALL_COOKIE = exports.PAYWALL_COOKIE = 'voc_paywall';
var SHOW_LOGS = exports.SHOW_LOGS = document.location.search.indexOf('vam_debug=1') > -1 || document.location.search.indexOf('gdp_debug=1') > -1;
var DEFAULT_LOG_TEMPLATE = exports.DEFAULT_LOG_TEMPLATE = '[Ads Manager]';
var CONFIG_NAMESPACE = exports.CONFIG_NAMESPACE = 'vocento.config.vam';
var EDITIONS_NAMESPACE = exports.EDITIONS_NAMESPACE = 'vocento.site.editions';
var GPT_ID_VOCENTO = exports.GPT_ID_VOCENTO = '4900';
var GPT_READY = exports.GPT_READY = 'vam:gpt:ready';
var GPT_TIMEOUT = exports.GPT_TIMEOUT = 2000;
var TIMEOUT_POSICIONES_ESTANDAR = exports.TIMEOUT_POSICIONES_ESTANDAR = 3000;
var ALTOS_MINIMOS_DISPOSITIVOS = exports.ALTOS_MINIMOS_DISPOSITIVOS = {
  mobile: 0,
  tablet: 200,
  desktop: 300
};
var POSITION_FLUID = exports.POSITION_FLUID = "'fluid'";
var SLOT_RENDERED = exports.SLOT_RENDERED = 'vam:slotrendered';
var SLOT_EMPTY = exports.SLOT_EMPTY = 'vam:isempty';
var SLOT_VIEWABLE = exports.SLOT_VIEWABLE = 'vam:viewable';
var SLOT_INACTIVE = exports.SLOT_INACTIVE = 'vam:inactive';
var DEFAULTS = exports.DEFAULTS = {
  hideNoAds: true,
  refresh: false,
  responsive: false
};
var CAPTURADOR_WS = exports.CAPTURADOR_WS = '//publi.cmvocento.com/capturador/preview';
var MCRYPT_KEY = exports.MCRYPT_KEY = 'acsNdl09acs72AEdacsNdl09acs72AEd';
var VAM_CSS_URL = exports.VAM_CSS_URL = '//netssl.vocento.com/cmvocento/css/vam.css';
var JSON_GDP2_0 = exports.JSON_GDP2_0 = 0;
var JSON_GDP2_1 = exports.JSON_GDP2_1 = 1;
var JSON_GDP2_2 = exports.JSON_GDP2_2 = 2;
var NOMBRE_FORMATO_JSON = exports.NOMBRE_FORMATO_JSON = ['GDP2.0', 'GDP2.1', 'GDP2.2+'];
var GPT_URL = exports.GPT_URL = 'www.googletagservices.com/tag/js/gpt.js';

/* header bidding */
var HEADER_BIDDING_READY = exports.HEADER_BIDDING_READY = 'vam:headerbidding:ready';
var ENV_PREFIX_PRE = 'pre-';
var ENV_PREFIX_DES = 'des-';
var PREBID_URL = exports.PREBID_URL = function IIFE() {
  var url, defaultUrl, prefix;

  defaultUrl = 'prebid.js';
  if (document.location.hostname.indexOf('localhost') !== -1) return defaultUrl;

  url = 'static.vocento.com/vam/' + _package2.default.version + '/' + defaultUrl;
  prefix = (document.location.hostname.indexOf(ENV_PREFIX_PRE) === 0 ? ENV_PREFIX_PRE : null) || (document.location.hostname.indexOf(ENV_PREFIX_DES) === 0 ? ENV_PREFIX_DES : '');

  return '//' + prefix + url;
}();
var DEFAULT_PREBID_LOAD_TIMEOUT = exports.DEFAULT_PREBID_LOAD_TIMEOUT = 7000;
var AMAZON_URL = exports.AMAZON_URL = '//c.amazon-adsystem.com/aax2/apstag.js';
var DEFAULT_AMAZON_LOAD_TIMEOUT = exports.DEFAULT_AMAZON_LOAD_TIMEOUT = 7000;
var AMAZON_CONFIG = exports.AMAZON_CONFIG = {
  pubID: '3470', // Amazon publisher ID
  adServer: 'googletag' // AdServer type that contains apstag line-items
};

/* legacy */
var OLD_PREFIX = exports.OLD_PREFIX = 'publi_';
var NEW_SUFFIX = exports.NEW_SUFFIX = '-id';

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showLog = showLog;
exports.showWarn = showWarn;
exports.showError = showError;

var _constants = __webpack_require__(0);

function showLog() {
  var _console;

  _constants.SHOW_LOGS && (_console = console).log.apply(_console, [_constants.DEFAULT_LOG_TEMPLATE].concat(Array.prototype.slice.call(arguments)));
}

function showWarn() {
  var _console2;

  _constants.SHOW_LOGS && (_console2 = console).warn.apply(_console2, [_constants.DEFAULT_LOG_TEMPLATE].concat(Array.prototype.slice.call(arguments)));
}

function showError() {
  var _console3;

  _constants.SHOW_LOGS && (_console3 = console).error.apply(_console3, [_constants.DEFAULT_LOG_TEMPLATE].concat(Array.prototype.slice.call(arguments)));
}

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _evented = __webpack_require__(24);

var _evented2 = _interopRequireDefault(_evented);

var _deferred = __webpack_require__(25);

var _deferred2 = _interopRequireDefault(_deferred);

var _user = __webpack_require__(27);

var _user2 = _interopRequireDefault(_user);

var _mixin = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _scripts = {},
    _hasOwnProperty = Object.prototype.hasOwnProperty;

var Application = {
  load: function load(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var promise, script, src, key;

    src = url;
    key = url.split('?').shift();
    if (_hasOwnProperty.call(_scripts, key)) {
      return _scripts[key];
    }

    script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = true;
    options.text && (script.text = options.text);

    promise = new window.RSVP.Promise(function (resolve, reject) {
      script.onload = function () {
        return resolve(script);
      };
      script.onerror = reject;

      document.head.appendChild(script);
    });

    _scripts[key] = promise;
    return promise;
  }
};

(0, _mixin.extend)(Application, _evented2.default);
(0, _mixin.extend)(Application, _deferred2.default);
(0, _mixin.extend)(Application, _user2.default);

exports.default = Application;

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERSION = undefined;

__webpack_require__(22);

__webpack_require__(23);

var _package = __webpack_require__(4);

var _package2 = _interopRequireDefault(_package);

var _application = __webpack_require__(2);

var _application2 = _interopRequireDefault(_application);

var _advertising = __webpack_require__(28);

var _advertising2 = _interopRequireDefault(_advertising);

var _configManager = __webpack_require__(9);

var _configManager2 = _interopRequireDefault(_configManager);

var _utils = __webpack_require__(5);

var _constants = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _window = window,
    $ = _window.$;

var _initialized = false;

_legacyInit();
$(document).ready(function () {
  var config = _application2.default.lookup(_constants.CONFIG_NAMESPACE);

  config = !(0, _utils.isEmpty)(config) ? config : {
    media: window.configGDPMedio,
    options: window.configGDP
  };
  _init(config.media, config.options);
});

var VERSION = exports.VERSION = _package2.default.version;

/* Private */

/**
 * Build legacy object
 * @deprecated
 */
function _legacyInit() {
  window.Vocento = window.Vocento || {};
  window.Vocento.Publicidad = function () {};
  window.Vocento.Publicidad.prototype = {
    init: function init(jQuery, configGDPMedio, configGDP) {
      _init(configGDPMedio, configGDP);
    },
    printAds: function printAds(datos) {
      return _advertising2.default.printAds(datos);
    },
    getOasSitepage: function getOasSitepage() {
      return _advertising2.default.getOasSitepage.apply(_advertising2.default, arguments);
    },
    getSizesGoogle: function getSizesGoogle() {
      return _advertising2.default.getSizesGoogle.apply(_advertising2.default, arguments);
    },
    getValueUser: function getValueUser() {
      return _advertising2.default.getValueUser.apply(_advertising2.default, arguments);
    }
  };
}

function _init(configGDPMedio, configGDP) {
  var voontoApp = 'Voonto' in window && 'getInstance' in window.Voonto ? window.Voonto.getInstance() : undefined;
  var configManager;

  if (_initialized) {
    return;
  }

  if (!configGDPMedio || !configGDP) {
    throw Error('[Ads Manager] missing configuration');
  }

  _initialized = true;
  configManager = new _configManager2.default(configGDPMedio, configGDP);
  _advertising2.default.init(configManager);
  _printAds();

  if (voontoApp) {
    voontoApp.on('voonto:reload', _reload);
    voontoApp.on('vam:refresh', _refresh);
  }
  _application2.default.on('voonto:reload', _reload);
  _application2.default.on('vam:refresh', _refresh);
}

/**
 * Print Ads configured inside context or whole page
 * Config must be passed to Advertising.init before calling printAds()
 * @param {null|jQueryObject} context$
 */
function _printAds(context$) {
  $('[data-voc-vam]', context$).each(function () {
    _advertising2.default.printAds($(this));
  });
}

/**
 * Reload ads inside given context with given config
 * @param {jQueryEvent}       event
 * @param {null|jQueryObject} context$
 * @param {object}            configGDPMedioReload
 * @param {object}            configGDPReload
 */
function _reload(event, context$, configGDPMedioReload, configGDPReload) {
  var configManager = new _configManager2.default(configGDPMedioReload, configGDPReload);

  _advertising2.default.init(configManager, context$);
  _printAds(context$);
}

/**
 * Refresh the ads position received on 'data' parameter
 * @param {string|object} data
 */
function _refresh(event, data) {
  var params = typeof data === 'string' ? JSON.parse(data) : data;

  _advertising2.default.printAds(params);
}

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _constants = __webpack_require__(0);

// NOTE: jQuery checking
if (!('$' in window) || typeof window.$ !== 'function') {
  throw Error(_constants.DEFAULT_LOG_TEMPLATE + ' missing jQuery library on page');
}

// NOTE: Cookies checking
if (!('Cookies' in window) || typeof window.Cookies !== 'function') {
  throw Error(_constants.DEFAULT_LOG_TEMPLATE + ' missing Cookies library on page');
}

// NOTE: RSVP checking
if (!('RSVP' in window) || _typeof(window.RSVP) !== 'object') {
  throw Error(_constants.DEFAULT_LOG_TEMPLATE + ' missing RSVP library on page');
}

// NOTE: InView jQuery Plugin checking
if (!('event' in window.$) || !('special' in window.$.event) || !('inview' in window.$.event.special) || _typeof(window.$.event.special.inview) !== 'object') {
  throw Error(_constants.DEFAULT_LOG_TEMPLATE + ' missing InView jQuery plugin on page');
}

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _application = __webpack_require__(2);

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserTypes = Object.freeze({
  ANONYMOUS: 'anonimo'
}),
    Genders = Object.freeze({
  FEM: 'f',
  MAS: 'm'
}),
    VOCUSER_READY = 'vocuser:ready',
    VOCUSER_DATA = 'vocuser:userdata';

$(document).ready(function () {
  _application2.default.when(VOCUSER_READY).then(_onVocUserReady);
  $('body').on('vocento.gigya.products.onReady', function (event, gigyaux) {
    var gigyaUX;

    gigyaUX = gigyaux || window.gigyaUX;
    if (gigyaUX) {
      _onVocUserReady(gigyaUX);
    }
  });
});

/* Private */

function _ord() {
  return Math.random() * 10000000000000;
}

function _onVocUserReady(gigyaux) {
  if (gigyaux.getUserType() === UserTypes.ANONYMOUS) {
    $('head').append('<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=' + _ord() + ';dc_seg=76171930?" width="1" height="1" border="0" />');
  } else {
    $('head').append('<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=' + _ord() + ';dc_seg=76172050?" width="1" height="1" border="0" />');
    if (typeof Voonto !== 'undefined') {
      _application2.default.when(VOCUSER_DATA).then(function (userData) {
        var gender, age;

        // NOTE: vocUserData promise object
        if (userData.responseGetUserInfo) {
          gender = userData.responseGetUserInfo.user && userData.responseGetUserInfo.user.gender ? userData.responseGetUserInfo.user.gender : null;
          age = userData.responseGetUserInfo.user && userData.responseGetUserInfo.user.age ? userData.responseGetUserInfo.user.age : null;
        }
        _onVocUserData(gender, age);
      });
    } else {
      $('body').on('vocento.gigya.accounts.onDataReady', function (event) {
        var gender, age;

        // NOTE: vocUserData promise object
        if (event.gigya_event) {
          gender = event.gigya_event.profile && event.gigya_event.profile.gender ? event.gigya_event.profile.gender : null;
          age = event.gigya_event.profile && event.gigya_event.profile.age ? event.gigya_event.profile.age : null;
        }
        _onVocUserData(gender, age);
      });
    }
  }
}

function _onVocUserData(gender, age) {
  switch (gender) {
    case Genders.FEM:
      $('head').append('<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=' + _ord() + ';dc_seg=75868810?" width="1" height="1" border="0" />');
      break;
    case Genders.MAS:
      $('head').append('<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=' + _ord() + ';dc_seg=75868570?" width="1" height="1" border="0" />');
      break;
    default:
  }

  switch (true) {
    case age !== '' && age <= 17:
      $('head').append('<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=' + _ord() + ';dc_seg=75867610?" width="1" height="1" border="0" />');
      break;
    case age >= 18 && age <= 24:
      $('head').append('<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=' + _ord() + ';dc_seg=75867850?" width="1" height="1" border="0" />');
      break;
    case age >= 25 && age <= 34:
      $('head').append('<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=' + _ord() + ';dc_seg=75867970?" width="1" height="1" border="0" />');
      break;
    case age >= 35 && age <= 44:
      $('head').append('<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=' + _ord() + ';dc_seg=75868210?" width="1" height="1" border="0" />');
      break;
    case age >= 45 && age <= 54:
      $('head').append('<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=' + _ord() + ';dc_seg=75868330?" width="1" height="1" border="0" />');
      break;
    case age !== '' && age < 54:
      $('head').append('<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=' + _ord() + ';dc_seg=75868450?" width="1" height="1" border="0" />');
      break;
    default:
  }
}

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logger = __webpack_require__(1);

var Evented = Object.preventExtensions({
  on: function on() {
    var _window$$;

    (_window$$ = window.$(this)).on.apply(_window$$, arguments);
  },
  one: function one() {
    var _window$$2;

    (_window$$2 = window.$(this)).one.apply(_window$$2, arguments);
  },
  off: function off() {
    var _window$$3;

    (_window$$3 = window.$(this)).off.apply(_window$$3, arguments);
  },
  trigger: function trigger() {
    var _window$$4;

    _logger.showLog.apply(undefined, ['Evented::trigger'].concat(Array.prototype.slice.call(arguments)));
    (_window$$4 = window.$(this)).trigger.apply(_window$$4, arguments);
  }
});

exports.default = Evented;

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _globalized = __webpack_require__(26);

var _globalized2 = _interopRequireDefault(_globalized);

var _mixin = __webpack_require__(8);

var _constants = __webpack_require__(0);

var _logger = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _defers = {},
    _hasOwnProperty = Object.prototype.hasOwnProperty;

var Deferred = {
  whenUntil: function whenUntil(promiseNS) {
    var _this = this;

    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.DEFAULT_TIMEOUT;

    (0, _logger.showLog)('[Deferred] whenUntil', { promiseNS: promiseNS, time: time });
    return new window.RSVP.Promise(function (resolve, reject) {
      setTimeout(reject, time);
      _this.when(promiseNS).then(resolve);
    });
  },
  when: function when(promiseNS) {
    var owner, name, global;

    (0, _logger.showLog)('[Deferred] when', promiseNS);

    if (!promiseNS) {
      throw Error(_constants.DEFAULT_LOG_TEMPLATE + ' [Deferred] At least 1 argument needed. 0 passed.');
    }

    var _promiseNS$split = promiseNS.split(':');

    var _promiseNS$split2 = _slicedToArray(_promiseNS$split, 2);

    owner = _promiseNS$split2[0];
    name = _promiseNS$split2[1];

    if (!owner || !name) {
      throw Error(_constants.DEFAULT_LOG_TEMPLATE + ' [Deferred] Illegal promise namespace name. Expected "owner:name".');
    }

    if (_hasOwnProperty.call(_defers, promiseNS)) {
      return _defers[promiseNS].promise;
    }

    global = this.createGlobal(_constants.NAMESPACE + '.' + owner + '.' + _constants.PROMISES_PROPERTY);
    global[name] = window.RSVP.defer();
    _defers[promiseNS] = global[name];

    return global[name].promise;
  },
  promised: function promised(promiseNS, value) {
    var owner, name, global;

    (0, _logger.showLog)('[Deferred] promised', { promiseNS: promiseNS, value: value });

    if (!promiseNS) {
      throw Error(_constants.DEFAULT_LOG_TEMPLATE + ' [Deferred] At least 1 argument needed. 0 passed.');
    }

    var _promiseNS$split3 = promiseNS.split(':');

    var _promiseNS$split4 = _slicedToArray(_promiseNS$split3, 2);

    owner = _promiseNS$split4[0];
    name = _promiseNS$split4[1];

    if (!owner || !name) {
      throw Error(_constants.DEFAULT_LOG_TEMPLATE + ' [Deferred] Illegal promise namespace name. Expected "owner:name".');
    }

    if (_hasOwnProperty.call(_defers, promiseNS)) {
      _defers[promiseNS].resolve(value);
      return this;
    }

    global = this.createGlobal(_constants.NAMESPACE + '.' + owner + '.' + _constants.PROMISES_PROPERTY);
    global[name] = window.RSVP.defer();
    global[name].resolve(value);
    _defers[promiseNS] = global[name];

    return this;
  }
};

(0, _mixin.extend)(Deferred, _globalized2.default);

exports.default = Deferred;

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(0);

var Globalized = {
  createGlobal: function createGlobal(namespace) {
    var nso = window;

    if (!namespace) {
      return undefined;
    }

    namespace.split('.').forEach(function (prop) {
      nso[prop] = nso[prop] || {};
      nso = nso[prop];
    });

    return nso;
  },
  lookup: function lookup() {
    var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.NAMESPACE;
    var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

    return namespace.split('.').reduce(function (that, o) {
      return that && o in that ? that[o] : {};
    }, root);
  }
};

exports.default = Globalized;

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(0);

var _window = window,
    Cookies = _window.Cookies,
    UserType = Object.freeze({
  ANONYMOUS: 'anonimo',
  REGISTERED: 'registrado',
  SUBSCRIBER: 'suscriptor',
  TRIAL: 'trial'
});


var User = {
  getUserType: function getUserType() {
    var userType, paywall, pwUserType, vocUid, cookie;

    vocUid = decodeURIComponent(Cookies.get(_constants.VOCUSER_COOKIE));
    cookie = vocUid === 'undefined' ? {} : _jsonParse(vocUid);
    userType = UserType.ANONYMOUS; // <'anonimo' | 'registrado' | 'trial' | 'suscriptor'>
    paywall = Cookies.get(_constants.PAYWALL_COOKIE);
    if (paywall) {
      pwUserType = paywall.split('|').pop();
    }

    if (pwUserType) {
      userType = pwUserType;
    } else if (cookie.uid) {
      userType = UserType.REGISTERED;
    }

    return userType;
  }
};

exports.default = User;

/* Private */

function _jsonParse(vocUid) {
  var result;

  try {
    result = JSON.parse(vocUid);
  } catch (e1) {
    // NOTE: fix issue https://agil.vocento.com/browse/MEC-2575
    vocUid = vocUid.replace(/\+/g, '');
    try {
      result = JSON.parse(vocUid);
    } catch (e2) {
      result = {};
    }
  }

  return result;
}

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _package = __webpack_require__(4);

var _providerManager = __webpack_require__(29);

var _providerManager2 = _interopRequireDefault(_providerManager);

var _application = __webpack_require__(2);

var _application2 = _interopRequireDefault(_application);

var _configManager4 = __webpack_require__(9);

var _configManager5 = _interopRequireDefault(_configManager4);

var _utils = __webpack_require__(5);

var _logger = __webpack_require__(1);

var _constants = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _configManager = null,
    _standardDelayed = [],
    _gptInitialized = false,
    _insertedPositions = {},
    _notDisplayedSlots = [],
    _completadasPriorizadas = false;

var Advertising = function () {
  function Advertising() {
    _classCallCheck(this, Advertising);
  }

  _createClass(Advertising, null, [{
    key: 'init',

    /**
     * Function that initialize the advertising
     * @param {object}  app - Evented object
     * @param {object}  configGDPMedio
     * @param {object}  configGDP
     * @param {context} context$
     */
    value: function init(configManager, context$) {
      var kruxSegments, kruxUser;

      _configManager = null;
      _standardDelayed = [];
      _gptInitialized = false;
      _insertedPositions = {};
      _notDisplayedSlots = [];
      _completadasPriorizadas = false;

      _configManager = configManager;
      _configManager.context$ = context$;

      // Detectamos si se fuerza via URL alguna configuracion
      _configManager.checkConfigFromURL();

      if (!_configManager.configGDPMedio.activo) {
        (0, _logger.showWarn)('Advertising:init:The advertising has been deactivated in the configuration of the medium!');
        return;
      }
      (0, _logger.showLog)('Advertising:init:deviceType: ' + _configManager.deviceType + ' , pageType: ' + _configManager.pageType + ' , (Version ' + _package.version + ')');

      _configManager.processConfig();

      // Load HB and GPT libraries soon as posible for not penalize the ad visualization
      (0, _logger.showLog)('init:HeaderBidding init');
      _providerManager2.default.init(_configManager.configGDPMedio);
      (0, _utils.cargaLibreriaGPT)();

      // Inicializacion de la libreria GPT
      window.customcmd.push(function () {
        window.googletag.pubads().collapseEmptyDivs();
        kruxSegments = _application2.default.lookup('Krux.vocento.segments');
        kruxUser = _application2.default.lookup('Krux.vocento.user');
        if (_configManager.configGDPMedio.enableKrux && ['object', 'undefined'].indexOf(typeof kruxSegments === 'undefined' ? 'undefined' : _typeof(kruxSegments)) < 0 && ['object', 'undefined'].indexOf(typeof kruxUser === 'undefined' ? 'undefined' : _typeof(kruxUser)) < 0) {
          window.googletag.pubads().setTargeting('ksg', window.Krux.vocento.segments);
          window.googletag.pubads().setTargeting('kuid', window.Krux.vocento.user);
        }
        _configManager.configGDPMedio.singleRequest && window.googletag.pubads().enableSingleRequest();
        _configManager.configGDPMedio.syncRendering && window.googletag.pubads().enableSyncRendering();
        window.googletag.enableServices();

        // Disparamos el evento de GPT inicializada
        (0, _logger.showLog)('En constructor. Disparamos evento ' + _constants.GPT_READY);
        _application2.default.trigger(_constants.GPT_READY);
        _gptInitialized = true;
      });

      /* NOTE: Disparamos el evento de GPT inicializado tras N segundos para liberar posibles
               recursos que esten bloqueados */
      setTimeout(function () {
        if (!_gptInitialized) {
          (0, _logger.showWarn)('Advertising:init:Trigger event ' + _constants.GPT_READY + ' after ' + _constants.GPT_TIMEOUT);
          _application2.default.trigger(_constants.GPT_READY);
        }
      }, _constants.GPT_TIMEOUT);

      // Tratamiento de excepciones
      _configManager.checkExceptions();

      // Gestion de eventos de pintado de publicidad
      window.customcmd.push(function () {
        // Gestion de evento slotRenderEnded
        window.googletag.pubads().addEventListener('slotRenderEnded', function (ev) {
          var divId, position, container$, paramsSlot, index, found;

          divId = ev.slot.getSlotElementId();
          position = ev.slot.getTargeting('pos');
          container$ = $('#' + divId);
          paramsSlot = container$.data('params');
          index = -1;

          if (ev.isEmpty) {
            (0, _logger.showLog)('En constructor. slotRenderEnded. La posicion ' + position + ' isEmpty');
            container$.trigger(_constants.SLOT_EMPTY);
            if (_configManager.configGDPMedio.infoSlot) _infoSlotRender(paramsSlot, false);
          } else {
            (0, _logger.showLog)('En constructor. slotRenderEnded. La posicion ' + position + ' ha sido pintada en el DIV ' + divId);
            container$.trigger(_constants.SLOT_RENDERED);
            if (_configManager.configGDPMedio.infoSlot) _infoSlotRender(paramsSlot, true);
          }

          // Comprobacion si tiene eventos post_callback o post_event
          if (paramsSlot) {
            if (paramsSlot.post_callback) {
              (0, _logger.showLog)('En constructor. slotRenderEnded. La posicion ' + position + ' tiene el siguiente postCallback: ' + paramsSlot.post_callback);
              paramsSlot.post_callback();
            }

            if (paramsSlot.post_event) {
              (0, _logger.showLog)('En constructor. slotRenderEnded. La posicion ' + position + ' tiene el siguiente postEvent: ' + paramsSlot.post_event);
              _application2.default.trigger(paramsSlot.post_event);
            }
          }

          // Quitamos la posicion de la lista de posiciones priorizadas
          _configManager.removePrioritizedPosition();

          // Quitamos la posicion de la lista de posiciones estandar encoladas
          if (_configManager.thereArePrioritizedPositions() && _standardDelayed.length && !_configManager.isPrioritized(paramsSlot)) {
            found = _standardDelayed.find(function (parameters) {
              index++;
              return parameters.position === position[0];
            });
            if (found) {
              _standardDelayed.splice(index, 1);
            }
          }

          // Si esta era la ultima priorizada pintamos las estandar
          if (!_completadasPriorizadas && !_configManager.thereArePrioritizedPositions()) {
            _completadasPriorizadas = true;
            _displayStandarQueued();
          }
        });

        // Gestion de evento impressionViewable
        window.googletag.pubads().addEventListener('impressionViewable', function (ev) {
          var divId = ev.slot.getSlotElementId();
          var position = ev.slot.getTargeting('pos');
          var container$ = $('#' + divId);

          (0, _logger.showLog)('En constructor. impressionViewable. La posicion ' + position + ' es visible');
          container$.trigger(_constants.SLOT_VIEWABLE);
        });
      });

      /* NOTE: Si hay posiciones priorizadas las pintamos e invocamos el pintado de las estandar
               una vez pintadas estas */
      if (_configManager.thereArePrioritizedPositions()) {
        _displayPrioritized();

        /* NOTE: Si han transcurrido N segundos y todavia no se han lanzado las posiciones
                 estandar las forzamos */
        setTimeout(function () {
          if (_standardDelayed.length) {
            (0, _logger.showWarn)('Advertising:init:Display queued positions after ' + _constants.TIMEOUT_POSICIONES_ESTANDAR);
            _completadasPriorizadas = true;
            _displayStandarQueued();
          }
        }, _constants.TIMEOUT_POSICIONES_ESTANDAR);
      }
    }

    /**
     * Muestra la Advertising.
     * @param {Object} datos - Puede ser un DIV obtenido con jQuery con los atributos de
     *                         configuracion, o bien un objeto JSON con la configuracion a aplicar
     *
     * Descripcion de parametros que puede contener el objeto JSON:
     *      position      => string. Posicion publicitaria a mostrar
     *      id            => string. ID del elemento HTML en el que se muestra
     *      serverType    => string. Servidor de publicidad a usar
     *      hideNoAds     => boolean. Oculta el elemento HTML si el adserver no ha devuelto publi
     *      outOfPage     => boolean. Determina si el slot de publicidad es outOfPage o no. Por
     *                                defecto vale false
     *      defineSlot    => boolean. Indica si hay que definir o no el slot
     *      refresh       => boolean. Se pide la posicion de publicidad aunque ya se hubiera mostrado
     *                                antes. Por defecto false
     *      responsive    => Array. Indicamos si una publi se debe pintar solo en una(s)
     *                              determinada(s) resolucion(es)
     *      pre_callback  => function. Función javascript a la que invocar previamente
     *      pre_event     => string. evento de precondicion
     *      post_callback => function. Función javascript a la que invocar una vez disparado
     *                                 el slotRendered
     *      post_event    => string. evento a disparar una vez disparado evento de slotRendered
     *      oas           => string. Si se rellena es el OAS a utilizar en la posicion de publicidad
     *
     * Objeto Responsive
     *  El primer par de valores indica la resolucion, y en el segundo los tamanos de la posicion de
     *  publi a servir, el cual puede definirse como sigue:
     *    - vacio: []
     *    - single array: [ancho, alto]
     *    - multi array: [ [ancho1, alto1], [ancho2, alto2], ... ]
     *  - string: En cuyo caso usa la funcion ads.getSizesGoogle para obtener el array
     *
     * Ejemplo llamada:
     *  ads.printAds({'position': 'robapaginas', 'id': 'roba2', 'responsive': [
     *       [[0, 0], []] // Small Mobile
     *         ,[[350, 200], [300,150]] // Mobile
     *         ,[[750, 200], 'robapaginas'] // Tablet
     *         ,[[1050, 300], [[300,150],[300,250]]] // Desktop
     *   ]});
     */

  }, {
    key: 'printAds',
    value: function printAds(datos) {
      var params, position, idAds, prioritized, delayed;

      (0, _logger.showLog)('Advertising:printAds', datos);
      if (!_configManager.configGDPMedio.activo) {
        (0, _logger.showWarn)('Advertising:printAds:Ads was be disabled in Media Config');
        return;
      }

      params = _configManager.normalizaParams(datos);
      if (params === null) {
        (0, _logger.showWarn)('Advertising:printAds:Empty params', datos);
        return;
      }

      position = params.position;
      idAds = _configManager.getIdDiv(params);
      if (!_configManager.isActive(params)) {
        if ($('#' + idAds).length && params.hideNoAds) {
          (0, _logger.showWarn)('Advertising:printAds:Hiding ADs DIV container if hideNoAds is anabled', params);
          $('#' + idAds).hide();
        }
        (0, _logger.showWarn)('Advertising:printAds:Position ' + position + ' is not active', params);
        return;
      }

      if (!$('#' + idAds).length) {
        (0, _logger.showWarn)('Advertising:printAds:DIV with ID ' + idAds + ' does not exist', params);
        return;
      }

      if (params.serverType === 'google') {
        /* NOTE: Si estamos en modo preview comprobamos si esta posicion hay que traerla desde el
                 SW del capturador */
        if (_configManager.configGDPMedio.preview && _capturadorExistsPreview(params)) {
          (0, _logger.showLog)('Advertising:printAds:Preview mode. Getting form grabber service');
          _capturadorSetPreview(params);
          return;
        }

        (0, _logger.showLog)('Advertising:printAds:Check Ad-Type', params);
        prioritized = _configManager.isPrioritized(position);
        delayed = _configManager.isDelayed(position);

        if (prioritized && !delayed) {
          (0, _logger.showLog)('Advertising:printAds:Painting prioritized', params);
          _getAdGoogle(params, true);
        } else if (delayed) {
          (0, _logger.showLog)('Advertising:printAds:Wait for INVIEW event delayed', params);
          _displayDelayed(params);
        } else if (!_configManager.thereArePrioritizedPositions() || _completadasPriorizadas) {
          (0, _logger.showLog)('Advertising:printAds:Painting standard', params);
          _getAdGoogle(params, false);
        } else {
          (0, _logger.showLog)('Advertising:printAds:Painting queued standards', params);
          _standardDelayed.push(params);
        }
      } else {
        (0, _logger.showWarn)('Advertising:printAds:ServerType is different from google', params);
      }
    }

    /**
     * Get user type
     * NOTE: legacy code
     */

  }, {
    key: 'getValueUser',
    value: function getValueUser() {
      if (!_configManager) {
        throw Error('Advertising:getValueUser:Config object not initialized');
      }

      return _configManager.valueUserType;
    }

    /**
     * Get google sizes for a given position
     * NOTE: legacy code
     */

  }, {
    key: 'getSizesGoogle',
    value: function getSizesGoogle() {
      var _configManager2;

      if (!_configManager) {
        throw Error('Advertising:getSizesGoogle:Config object not initialized');
      }

      return (_configManager2 = _configManager).getSizesGoogle.apply(_configManager2, arguments);
    }

    /**
     * Get OAS value from config
     * NOTE: legacy code
     */

  }, {
    key: 'getOasSitepage',
    value: function getOasSitepage() {
      var _configManager3;

      if (!_configManager) {
        throw Error('Advertising:getOasSitepage:Config object not initialized');
      }

      return (_configManager3 = _configManager).getOasSitepage.apply(_configManager3, arguments);
    }
  }]);

  return Advertising;
}();

exports.default = Advertising;

/* Private */

/**
 * Funcion que genera el scriptText que pinta la Advertising.
 * @param  object params
 */

function _defineSlot(params) {
  var scriptText, legacyCmvkey, insertedPositionkey, hideText, targetingText, size, idAds, targetingsTags, deviceTypeTargeting, decryptedURL, pattern, isValid, decodedURLTargetings, chunksURLTargetings, topics, mappingObj, sizeMapping, defineSizeMapping;

  size = _configManager.getSizesGoogle(params.position);
  idAds = _configManager.getIdDiv(params);
  targetingsTags = params.tags || {};
  // Codigo para ocultar el div si no hay publi
  hideText = params.hideNoAds ? '.setCollapseEmptyDiv(true)' : '';
  targetingText = _configManager.globalTargetings;

  Object.keys(targetingsTags).forEach(function (key) {
    targetingText += '.setTargeting("' + key + '", "' + targetingsTags[key] + '")';
  });

  // Targeting con tipo de usuario de Gigya
  deviceTypeTargeting = _configManager.deviceType === 'mobile' ? 'm' : 'w';
  targetingText += '.setTargeting(\'st\', \'' + _configManager.valueUserType + '\').setTargeting(\'stt\', \'' + deviceTypeTargeting + _configManager.valueUserType + '\')';

  // Se comprueba si se fuerza algun targeting via URL con el parametro vam_cmvkey
  decryptedURL = _configManager5.default.decryptedURL();
  if (typeof window.location !== 'undefined' && (window.location.href.indexOf('vam_cmvkey=') > -1 || window.location.href.indexOf('cmvkey=') > -1) || decryptedURL !== '') {
    legacyCmvkey = window.location.href.indexOf('vam_cmvkey=') > -1 ? 'vam_cmvkey' : 'cmvkey';
    pattern = new RegExp('(\\?|&)' + legacyCmvkey + '=([^?&]+)');
    isValid = decryptedURL !== '' ? pattern.exec(decryptedURL) : pattern.exec(window.location.href);

    if (isValid) {
      try {
        decodedURLTargetings = decodeURIComponent(isValid[2]);
        chunksURLTargetings = decodedURLTargetings.split(',');

        chunksURLTargetings.forEach(function (chunck) {
          var pair, keyChunk, valueChunk;

          pair = chunck.split('=');
          keyChunk = pair[0];
          valueChunk = pair[1];
          targetingText += '.setTargeting("' + keyChunk + '", "' + valueChunk + '")';
        });
      } catch (e) {
        (0, _logger.showWarn)('Advertising:defineSlot:Error processing ' + legacyCmvkey + ': ' + e);
      }
    }
  }

  // Incluimos los topics como targeting si asi corresponde
  try {
    topics = _getTopics(false);
    if (topics.length) {
      targetingText += '.setTargeting("topics", "' + topics + '")';
    }
  } catch (e) {
    (0, _logger.showWarn)('Advertising:defineSlot:Error processing enableTopics: ' + e);
  }

  // Se comprueba si enableTpag esta habilitado
  try {
    if (_configManager.configGDPMedio.enableTpag) {
      targetingText += '.setTargeting("tpag", "' + _configManager.pageType + '")';
    }
  } catch (e) {
    (0, _logger.showWarn)('Advertising:defineSlot:Error processing tpag: ' + e);
  }

  // Comprobaciones para medios responsives
  mappingObj = {};
  sizeMapping = '';
  defineSizeMapping = '';
  if (!params.outOfPage && params.responsive && Array.isArray(params.responsive) && params.responsive.length > 0) {
    mappingObj = _getSizeMapping(params);
    sizeMapping = mappingObj && mappingObj.definition ? mappingObj.definition : '';
    defineSizeMapping = mappingObj && mappingObj.script ? mappingObj.script : '';
  }

  if (!params.outOfPage) {
    if (params.defineSlot) {
      scriptText = sizeMapping + 'window.' + _getNombreSlot(params) + ' = window.googletag.defineSlot(\'' + _configManager.getOasSitepage(params) + '\', ' + size + ', \'' + idAds + '\')' + defineSizeMapping + '.setTargeting(\'pos\',\'' + params.position + '\')' + targetingText + hideText + '.addService(googletag.pubads());';
    }
  } else if (params.defineSlot) {
    scriptText = sizeMapping + 'window.' + _getNombreSlot(params) + ' = window.googletag.defineOutOfPageSlot(\'' + _configManager.getOasSitepage(params) + '\', \'' + idAds + '\')' + defineSizeMapping + '.setTargeting(\'pos\',\'' + params.position + '\')' + targetingText + hideText + '.addService(googletag.pubads());';
  }

  insertedPositionkey = _getClavePosicionInsertada(params);
  _insertedPositions[insertedPositionkey] = scriptText;
  (0, _logger.showLog)('Advertising:defineSlot:Ads ID', idAds);
  window.customcmd.push(_executeDefineSlot(scriptText, params));
}

function _executeDefineSlot(scriptText, params) {
  (0, _logger.showLog)('En defineSlot. defineSlot: ' + scriptText);
  eval(scriptText);
  _notDisplayedSlots.push(params.position);
}

/**
 * Hace display de una posicion
 */
function _display(params) {
  // Comprobamos si la posicion esta en la lista de posiciones definidas y pendientes de display
  var index, idDiv;

  (0, _logger.showLog)('Advertising:display:Display position ' + params.position + ' with params', params);
  index = _notDisplayedSlots.indexOf(params.position);
  if (index < 0) {
    (0, _logger.showLog)('Advertising:display:Position ' + params.position + ' has already been displayed');
    return;
  }

  (0, _logger.showLog)('Advertising:display:Position ' + params.position + ' is not displayed yet');
  idDiv = _configManager.getIdDiv(params);
  if (!$('#' + idDiv).length) {
    (0, _logger.showWarn)('Advertising:display:DIV with ID ' + idDiv + ' does not exist');
    return;
  }
  (0, _logger.showLog)('Advertising:display:Queued position ' + params.position + ' to display');
  window.customcmd.push(function () {
    (0, _logger.showLog)('Advertising:display:Displaying ' + params.position);
    window.googletag.display(idDiv);

    /* NOTE: Si singleRequest esta habilitado un unico display sirve para todas las posiciones
              para las que hemos hecho defineSlot previamente. En caso contrario solo quitamos la
              posicion concreta de la lista.
    */
    if (_configManager.configGDPMedio.singleRequest) {
      _notDisplayedSlots = [];
    } else {
      _notDisplayedSlots.splice(index, 1);
    }
  });
}

/**
 * Funcion que obtiene las medidas en caso de que sea responsive.
 * FUTURE: move config to GDP
 * FUTURE: move logic to GoogleTag component
 * @param  object responsive
 * @return string sizeMapping
 */
function _getSizeMapping(params) {
  var mappingName, mappingObj, responsive, finalDefinition;

  mappingName = 'window.mapping_' + _getNombreSlot(params);
  mappingObj = {
    definition: mappingName + ' = window.googletag.sizeMapping()',
    script: '.defineSizeMapping(' + mappingName + ')'
  };
  responsive = params.responsive;
  (0, _logger.showLog)('Advertising:getSizeMapping:Resposive param for position ' + params.position, responsive);

  finalDefinition = responsive.reduce(function (definition, pair) {
    var addSize, viewportSize, responsiveSizes, singleSize;

    if (definition !== '' && !definition) return undefined;

    viewportSize = pair[0];
    if (pair.length !== 2 || !Array.isArray(viewportSize) || viewportSize.length !== 2) {
      (0, _logger.showWarn)('Advertising:getSizeMapping:Malformed responsive param in position ' + params.position + '. responsive: ' + responsive);
      return undefined;
    }

    addSize = '';
    responsiveSizes = pair[1];
    if (typeof responsiveSizes === 'string') {
      if (responsiveSizes.indexOf('fluid') !== -1) {
        responsiveSizes = _constants.POSITION_FLUID;
      } else {
        responsiveSizes = _configManager.getSizesGoogle(responsiveSizes);
        if (typeof responsiveSizes !== 'undefined' && typeof responsiveSizes === 'string') {
          responsiveSizes = JSON.parse(responsiveSizes);
        }
      }
    }
    if (!Array.isArray(responsiveSizes) && responsiveSizes !== _constants.POSITION_FLUID) {
      (0, _logger.showWarn)('Advertising:getSizeMapping:Malformed responsive param in position ' + params.position + '. responsive: ' + responsive);
      return undefined;
    }

    addSize = '[' + viewportSize[0] + ',' + viewportSize[1] + '],';
    if (responsiveSizes.length > 0 && Array.isArray(responsiveSizes[0])) {
      addSize += '[';
      for (var j = 0; j < responsiveSizes.length; j++) {
        singleSize = responsiveSizes[j];
        if (singleSize.length === 2) {
          addSize += (j === 0 ? '[' : ',[') + singleSize[0] + ',' + singleSize[1] + ']';
        }
      }
      addSize += ']';
    } else if (responsiveSizes.length === 2) {
      addSize += '[' + responsiveSizes[0] + ',' + responsiveSizes[1] + ']';
    } else if (responsiveSizes === _constants.POSITION_FLUID) {
      addSize += _constants.POSITION_FLUID;
    } else {
      addSize += '[]';
    }

    return definition + '.addSize(' + addSize + ')';
  }, '');

  if (!finalDefinition) return undefined;

  mappingObj.definition += finalDefinition + '.build();';

  return mappingObj;
}

/**
 * Lanza los printAds que se han encolado cuando hay priorizadas
 */
function _displayStandarQueued() {
  (0, _logger.showLog)('Advertising:displayStandarQueued:Display queued positions');
  while (_standardDelayed.length) {
    Advertising.printAds(_standardDelayed.shift());
  }
}

/**
 * Funcion para pintar la publicidad priorizada
 */
function _displayPrioritized() {
  (0, _logger.showLog)('Advertising:pintaPriorizadas:Painting the following positions : ' + _configManager.prioritizedPositions);
  _pintaListaPosiciones(_configManager.prioritizedPositions, true);
}

/**
 * Funcion que recorre y pinta una lista de posiciones.
 * Si singleRequest esta habilitado las posiciones priorizadas funcionan como un Roadblock y se
 * piden todas juntas (no llevaran eventos ni callbacks)
 */
function _pintaListaPosiciones(listaPositions, sonPosicionesPriorizadas) {
  if (_configManager.configGDPMedio.singleRequest && sonPosicionesPriorizadas) {
    (0, _logger.showLog)('Advertising:pintaListaPosiciones:There is prioritized positions and SingleRequest is enabled -> get with Roadblock');

    window.customcmd.push(function () {
      var params, container$, posCuyoDivExiste;

      posCuyoDivExiste = null;
      listaPositions.forEach(function (position) {
        params = { position: position };

        if (!_configManager.existePosEnConfigGDPMedio(position)) {
          (0, _logger.showWarn)('Advertising:pintaListaPosiciones:SingleRequest position ' + position + ' does not exist configGDPMedio');
          return;
        }

        if (!_configManager.isActive(params)) {
          (0, _logger.showWarn)('Advertising:pintaListaPosiciones:SingleRequest position ' + position + ' is NOT active');
          return;
        }

        // Recuperamos los parametros del DIV en caso de que exista en la pagina
        container$ = $('[data-voc-vam-position = \'' + position + '\']', _configManager.context$);
        if (container$.length) {
          params = _configManager.normalizaParams(container$);
          if (posCuyoDivExiste === null) posCuyoDivExiste = params;
        } else {
          // NOTE: find legacy DIV
          container$ = $('#' + _configManager.getIdDiv(params));
          if (container$.length) {
            params = _configManager.normalizaParams(params);
            if (posCuyoDivExiste === null) {
              posCuyoDivExiste = params;
            }
          } else {
            (0, _logger.showWarn)('En pintaListaPosiciones. No existe el DIV de la posicion priorizada ' + position);
          }
        }
        if ('id' in params) {
          (0, _logger.showLog)('En pintaListaPosiciones. Llamando a defineSlot: ' + JSON.stringify(params));
          _defineSlot(params);
        }
      });

      if (posCuyoDivExiste === null) {
        (0, _logger.showError)('ERROR En pintaListaPosiciones. No existe el DIV de ninguna de las posiciones priorizadas en la pagina, por lo que no se hara el display');
      } else {
        params = posCuyoDivExiste;
      }

      // NOTE: If there is Header Bidding wait for bidders promises
      if (_providerManager2.default.isActive()) {
        (0, _logger.showLog)('pintaListaPosiciones:Waiting for HB`s promises to be solved');
        _application2.default.when(_constants.HEADER_BIDDING_READY).then(function () {
          (0, _logger.showLog)('pintaListaPosiciones:HB promises resolved');
          _providerManager2.default.setTargetings();
          (0, _logger.showLog)('pintaListaPosiciones:Params object', params);
          _display(params);
        });
      } else {
        (0, _logger.showLog)('En pintaListaPosiciones. Print without wait HB');
        _display(params);
      }
    });
  } else {
    !_configManager.configGDPMedio.singleRequest && (0, _logger.showLog)('Advertising:pintaListaPosiciones:SingleRequest DISABLED');
    !sonPosicionesPriorizadas && (0, _logger.showLog)('Advertising:pintaListaPosiciones:There are NOT prioritized positions');
    // window.customcmd.push(function () {
    listaPositions.forEach(function (position) {
      var params, container$, legacyParams;

      if (!_configManager.existePosEnConfigGDPMedio(position)) {
        (0, _logger.showWarn)('Advertising:pintaListaPosiciones:Prioritized position ' + position + ' does not exist configGDPMedio');
        return;
      }

      params = { position: position };
      if (!_configManager.isActive(params)) {
        (0, _logger.showWarn)('Advertising:pintaListaPosiciones:Prioritized position ' + position + ' is NOT active');
        return;
      }

      // Recuperamos los paramteros del DIV en caso de que exista en la pagina
      container$ = $('[data-voc-vam-position = \'' + position + '\']', _configManager.context$);
      if (container$.length) {
        params = _configManager.normalizaParams(container$);
      } else {
        container$ = $('#' + _configManager.getIdDiv(params));
        if (container$.length) {
          legacyParams = _configManager.normalizaParams(container$);
        }
        params = !legacyParams ? _configManager.normalizaParams(params) : legacyParams;
      }

      (0, _logger.showLog)('Advertising:pintaListaPosiciones:Calling printAds with', params);
      Advertising.printAds(params);
    });
    // });
  }
}

/**
 * Display delayed positions when it is on viewport
 * @param {object} params
 */
function _displayDelayed(params) {
  var idAds = _configManager.getIdDiv(params);

  $('#' + idAds).on('inview', function (event, isInView) {
    (0, _logger.showLog)('Advertising:displayDelayed:INVIEW_EVENT trigger', params, event, isInView);
    if (isInView) {
      (0, _logger.showLog)('Advertising:displayDelayed:Painting delayed', idAds, params);
      _getAdGoogle(params, false);
    }
  });
}

/**
 * Pintado de publicidad de GPT
 */
function _getAdGoogle(params, esPosPriorizada) {
  if (!_configManager.configGDPMedio.activo) {
    (0, _logger.showWarn)('Advertising:getAdGoogle:Ads was be disabled in Media Config');
    return;
  }

  (0, _logger.showLog)('Advertising:getAdGoogle:Queuing with', params);
  window.customcmd.push(function () {
    var idDiv, eventParams, tParams, key, hasPreevent;

    if (!_configManager.existePosEnConfigGDPMedio(params.position)) {
      (0, _logger.showWarn)('Advertising:getAdGoogle:Position ' + params.position + ' does not exist in configGDPMedio');
      return;
    }

    (0, _logger.showLog)('Advertising:getAdGoogle:googletag exec with', params);
    idDiv = _configManager.getIdDiv(params);
    eventParams = _getEventsPosition(params);

    tParams = params;
    tParams.pre_callback = eventParams.pre_callback;
    tParams.pre_event = eventParams.pre_event;

    tParams.post_callback = eventParams.post_callback;
    tParams.post_event = eventParams.post_event;
    (0, _logger.showLog)('Advertising:getAdGoogle:Set params to DIV with id = ', idDiv);
    $('#' + idDiv).data('params', tParams);

    key = _getClavePosicionInsertada(params);
    if (!_insertedPositions[key]) {
      hasPreevent = false;
      if (params.defineSlot) {
        (0, _logger.showLog)('Advertising:getAdGoogle:defineSlot', params);
        _defineSlot(params);
        if (!esPosPriorizada) {
          (0, _logger.showLog)('Advertising:getAdGoogle:It is not prioritized', params);
          if (eventParams.pre_callback && !eventParams.pre_event) {
            eventParams.pre_callback();
          } else if (eventParams.pre_event) {
            (0, _logger.showLog)('Advertising:getAdGoogle:Has pre-event', params);
            hasPreevent = true;
            _application2.default.one(eventParams.pre_event, params, function () {
              // NOTE: If there is Header Bidding wait for bidders promises
              if (_providerManager2.default.isActive()) {
                (0, _logger.showLog)('Advertising:getAdGoogle:Waiting for HB`s promises to be solved');
                _application2.default.when(_constants.HEADER_BIDDING_READY).then(function () {
                  (0, _logger.showLog)('Advertising:getAdGoogle:HB promises resolved with preEvents', params);
                  if (params.pre_callback) {
                    params.pre_callback();
                  }
                  _providerManager2.default.setTargetings();
                  _display(params);
                });
              }
            });
          } else {
            (0, _logger.showLog)('Advertising:getAdGoogle:Has NO pre-event', params);
            if (_providerManager2.default.isActive()) {
              hasPreevent = true;
              (0, _logger.showLog)('Advertising:getAdGoogle:Waiting for HB`s promises to be solved');
              _application2.default.when(_constants.HEADER_BIDDING_READY).then(function () {
                (0, _logger.showLog)('Advertising:getAdGoogle:HB promises resolved without preEvents with', params);
                if (params.pre_callback) {
                  params.pre_callback();
                }
                _providerManager2.default.setTargetings();
                _display(params);
              });
            }
          }
        } else {
          (0, _logger.showLog)('Advertising:getAdGoogle:Is prioritized', params);
          if (_providerManager2.default.isActive()) {
            hasPreevent = true;
            (0, _logger.showLog)('Advertising:getAdGoogle:Waiting for HB`s promises to be solved');
            _application2.default.when(_constants.HEADER_BIDDING_READY).then(function () {
              (0, _logger.showLog)('Advertising:getAdGoogle:HB promises resolved on prioritized position with', params);
              _providerManager2.default.setTargetings();
              _display(params);
            });
          }
        }
      }

      // No tiene evento de activacion
      if (!hasPreevent) {
        (0, _logger.showLog)('Advertising:getAdGoogle:Has no pre-event. Painting', params);
        _providerManager2.default.setTargetings();
        _display(params);
      }
    } else {
      (0, _logger.showLog)('Advertising:getAdGoogle:Position ' + params.position + ' has already been previously invoked. Checking the value of the refresh parameter', params.refresh);
      if (params.refresh) _pintarPosicionRefresh(params);
    }
  });
}

/**
 * Funcion que recuperar si tiene evento pre o post callback, los parametros llegados por funcion
 * prevalecen sobre los del CONFIG
 * @param  object params
 */
function _getEventsPosition(params) {
  var tipoDispositivoAux, positionEvents;

  tipoDispositivoAux = _configManager.deviceType;
  positionEvents = _application2.default.lookup('posicion_' + tipoDispositivoAux + '["' + params.position + '"]', _configManager.configGDP);

  if ((0, _utils.isEmpty)(positionEvents)) return positionEvents;

  positionEvents.pre_callback = params.pre_callback || params.pre_callback;
  positionEvents.pre_event = params.pre_event || params.pre_event;
  positionEvents.post_callback = params.post_callback || params.post_callback;
  positionEvents.post_event = params.post_event || params.post_event;

  return positionEvents;
}

/**
 * Devuelve el nombre de la variable que almacenara el slot
 */
function _getNombreSlot(params) {
  var dynamicId, dynamic;

  dynamicId = _configManager.dynamicId;
  dynamic = dynamicId ? '_' + dynamicId : '';

  return 'slot_' + params.position.replace('-', '_') + dynamic;
}

/**
 * Clave unica de la posicion
 */
function _getClavePosicionInsertada(params) {
  return _getNombreSlot(params) + '_' + _configManager.getIdDiv(params);
}

/**
 * Refresh de una posicion
 */
function _pintarPosicionRefresh(params) {
  (0, _logger.showLog)('En pintarPosicionRefresh. Refrescamos la posicion ' + params.position);
  window.googletag.pubads().refresh([_application2.default.lookup(_getNombreSlot(params))]);
}

/**
 * INICIO: Renderizado de tablas de informacion cuando vam_info_slot=1
 * --------------------------------------------------------------------------
 */
/**
 * Metodo de entrada de tablas de informacion
 */
function _infoSlotRender(params, isSlotRendered) {
  var idDiv, container$, width, height, dimension, arrayObj, numSlots, numTopics, numOas, max;

  idDiv = _configManager.getIdDiv(params);
  container$ = $('#' + idDiv);
  width = $('#' + idDiv + ' div iframe').width();
  height = $('#' + idDiv + ' div iframe').height();

  // Obtenemos el tamano de la publi pintada y la borramos
  if (isSlotRendered) {
    container$.empty();
  } else {
    // Si DFP devuelve isEmpty cogemos la primera dimension del array, o 150x150 si es fluid
    try {
      height = 150;
      width = 150;
      dimension = _configManager.getSizesGoogle(params.position);
      if (dimension && dimension.indexOf('fluid') < 0) {
        arrayObj = JSON.parse(dimension);

        if (Array.isArray(arrayObj[0])) {
          width = arrayObj[0][0];
          height = arrayObj[0][1];
        } else {
          width = arrayObj[0];
          height = arrayObj[1];
        }
      }
    } catch (e) {
      (0, _logger.showError)('Advertising:infoSlotRender:Error building size.', e);
    }

    container$.show();
  }

  // Rectangulo con color azul o rojo (si es local)
  container$.addClass('gdp_infoSlot_rectangle').html('<div><p style="width: ' + width + 'px; height: ' + height + 'px;">' + params.position + ' ' + _infoSlotFormateaDimensiones(params) + '</p></div>');
  if (_isLocalPosition(params)) container$.addClass('gdp_infoSlot_localPosition');
  if (!isSlotRendered) container$.addClass('gdp_infoSlot_inactive');

  if (!$('#gdp_infoSlot_tableInfo').length > 0) {
    $('body').append('<div class="display" id="gdp_infoSlot_tableInfo"></div>');
  }

  // Tablas de info adicional
  _infoSlotRenderSlots(params);
  _infoSlotRenderTopics();
  _infoSlotRenderOAS(params);

  numSlots = $('#gdp_infoSlot_tableInfo-slots').length > 0 ? $('#gdp_infoSlot_tableInfo-slots tbody tr').length : 0;
  numTopics = $('#gdp_infoSlot_tableInfo-topics').length > 0 ? $('#gdp_infoSlot_tableInfo-topics tbody tr').length : 0;
  numOas = $('#gdp_infoSlot_tableInfo-oas').length > 0 ? $('#gdp_infoSlot_tableInfo-oas tbody tr').length : 0;
  max = Math.max(numSlots, numTopics);
  if (max > numSlots && $('#gdp_infoSlot_tableInfo-slots').length > 0) {
    for (var i = 0; i < max - numSlots; i++) {
      $('#gdp_infoSlot_tableInfo-slots tbody').append('<tr><td>&nbsp;</td></tr>');
    }
  }
  if (max > numTopics && $('#gdp_infoSlot_tableInfo-topics').length > 0) {
    for (var _i = 0; _i < max - numTopics; _i++) {
      $('#gdp_infoSlot_tableInfo-topics tbody').append('<tr><td>&nbsp;</td></tr>');
    }
  }
  if (max > numOas && $('#gdp_infoSlot_tableInfo-oas').length > 0) {
    for (var _i2 = 0; _i2 < max - numOas; _i2++) {
      $('#gdp_infoSlot_tableInfo-oas tbody').append('<tr><td>&nbsp;</td></tr>');
    }
  }
}

function _applyFilter(value) {
  return value.replace(new RegExp("'fluid'", 'g'), '[fluid]').replace(new RegExp('\\],\\[', 'g'), '_').replace(new RegExp(',', 'g'), 'x').replace(new RegExp('\\[', 'g'), '').replace(new RegExp('\\]', 'g'), '').replace(new RegExp('_', 'g'), ',');
}

function _infoSlotFormateaDimensiones(params) {
  var result, dimensionsArray, mappingObj, sizeMapping, dimension, resolution, notRepeatedDimensions;

  result = '';
  dimensionsArray = [];
  mappingObj = {};
  sizeMapping = '';

  try {
    if (params.outOfPage) {
      dimensionsArray.push('oop');
    } else if (params.responsive && Array.isArray(params.responsive) && params.responsive.length > 0) {
      mappingObj = _getSizeMapping(params);
      sizeMapping = typeof mappingObj !== 'undefined' && typeof mappingObj.definition !== 'undefined' ? mappingObj.definition : '';
      sizeMapping.split('.').forEach(function (size) {
        if (size.indexOf('addSize') > -1) {
          size = size.replace(new RegExp('addSize\\(', 'g'), '').replace(new RegExp('\\)', 'g'), '');
          dimensionsArray.push(size);
        }
      });
    } else {
      dimensionsArray.push(_application2.default.lookup('posicion_' + _configManager.deviceType + '["' + params.position + '"].dimensiones', _configManager.configGDPMedio));
    }

    if (Array.isArray(dimensionsArray)) {
      if (params.outOfPage) {
        // Posicion OutOfPage
        result += '(oop)';
      } else if (!params.responsive) {
        // Posicion no responsive
        dimension = _applyFilter(dimensionsArray[0]);
        result += '(' + dimension + ')';
      } else {
        // Posicion responsive
        notRepeatedDimensions = new Set();
        dimensionsArray.forEach(function (dimen) {
          var filtered = _applyFilter(dimen);

          // Quitamos la resolucion
          resolution = filtered.substring(0, filtered.indexOf(','));
          dimension = filtered.substring(filtered.indexOf(',') + 1);
          notRepeatedDimensions.add(dimension);
          result += '<br>' + resolution + ': (' + dimension + ')';
        });

        // Si todas las dimensiones de responsive son la misma escribimos solo una
        if (notRepeatedDimensions.size === 1) result = '(' + dimension + ')';
      }
    }
  } catch (err) {
    (0, _logger.showError)('Advertising:infoSlotFormateaDimensiones:Error', err);
  }

  return result;
}

/**
 * Tabla de informacion de SLOTS
 */
function _infoSlotRenderSlots(params) {
  if (!$('#gdp_infoSlot_tableInfo-slots').length) {
    $('#gdp_infoSlot_tableInfo').append('<table cellpadding="0" cellspacing="0" border="1" class="display" id="gdp_infoSlot_tableInfo-slots"><thead></thead><tbody></tbody></table>');
    $('#gdp_infoSlot_tableInfo-slots thead').append('<th>posiciones</th>');
  }
  $('#gdp_infoSlot_tableInfo-slots tbody').append('<tr><td>' + params.position + '</td></tr>');
}

/**
 * Tabla de informacion de TOPICS
 */
function _infoSlotRenderTopics() {
  var topics = _getTopics(true);
  if (topics.length > 0) {
    if (!$('#gdp_infoSlot_tableInfo-topics')) {
      $('#gdp_infoSlot_tableInfo').append('<table cellpadding="0" cellspacing="0" border="1" class="display" id="gdp_infoSlot_tableInfo-topics" ><thead></thead><tbody></tbody></table>');
      $('#gdp_infoSlot_tableInfo-topics thead').append('<th>topics</th>');

      topics.forEach(function (topic) {
        $('#gdp_infoSlot_tableInfo-topics tbody').append('<tr><td>' + topic + '</td></tr>');
      });
    }
  }
}

/**
 * Tabla de informacion de OAS
 */
function _infoSlotRenderOAS(params) {
  if (!$('#gdp_infoSlot_tableInfo-oas')) {
    $('#gdp_infoSlot_tableInfo').append('<table cellpadding="0" cellspacing="0" border="1" class="display" id="gdp_infoSlot_tableInfo-oas"><thead></thead><tbody></tbody></table>');
    $('#gdp_infoSlot_tableInfo-oas thead').append('<th>oas</th>');
    $('#gdp_infoSlot_tableInfo-oas tbody').append('<tr><td>' + _configManager.getOasSitepage(params) + '</td></tr>');
  }
}

/**
 * Devuelve un array con los topics que contiene la pagina, en caso de que los contenga y que
 * enableTopics este habilitado.
 * @return array
 */
function _getTopics(forzarEnableTopics) {
  var topics = [];

  if ((_configManager.configGDPMedio.enableTopics || forzarEnableTopics) && window.voc_top) {
    topics = window.voc_top.split(',');
  }

  return topics;
}

/**
 * Funcion que devuelve true si la posicion es local, false si no lo es
 * @return boolean
 */
function _isLocalPosition(params) {
  return params.position.includes('_local');
}
/**
 * FIN: Renderizado de tablas de informacion cuando vam_info_slot=1
 * --------------------------------------------------------------------------
 */

/**
 * INICIO: Capturador (modo preview)
 * --------------------------------------------------------------------------
 */

/**
 * Devuelve true si hay preview para la posicion indicada o false en caso contrario
 * @returns {boolean}
 */
function _capturadorExistsPreview(params) {
  return _configManager.capturadorDataPreview && _configManager.capturadorDataPreview[params.position];
}

/**
 * funcion que cambia la publicidad por defecto, por una que se indica
 */
function _capturadorSetPreview(params) {
  var previewJSON, preview, idDiv, div, creatividad;

  try {
    previewJSON = JSON.parse(_configManager.capturadorDataPreview[params.position]);
    preview = previewJSON[0];
    idDiv = _configManager.getIdDiv(params);
    creatividad = '<iframe id="' + idDiv + '-iframe" name="' + preview.name + '" src="' + preview.previewUrl + '" width="' + preview.size.width + '" height="' + preview.size.height + '" scrolling="no" frameborder="0"></iframe>';
    div = $('#' + idDiv);
    div.empty();
    div.html(creatividad);
    (0, _logger.showLog)('En capturadorSetPreview. Pintada preview para la posicion ' + params.position);
  } catch (err) {
    (0, _logger.showError)('Advertising:capturadorSetPreview:Error', err);
  }
}
/**
 * FIN: Capturador (modo preview)
 * --------------------------------------------------------------------------
 */

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = __webpack_require__(2);

var _application2 = _interopRequireDefault(_application);

var _amazon = __webpack_require__(30);

var _amazon2 = _interopRequireDefault(_amazon);

var _prebid = __webpack_require__(32);

var _prebid2 = _interopRequireDefault(_prebid);

var _logger = __webpack_require__(1);

var _constants = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GATEWAYS = [_amazon2.default, _prebid2.default];
var _window = window,
    RSVP = _window.RSVP;

var _gatewaysPromises = [];
var _gatewaysAdded = [];

window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];
window.customcmd = window.customcmd || [];

exports.default = Object.preventExtensions({
  /**
   * Get promises from gateways.
   * NOTE: Init method must be call before isActive method
   * @param {string}  device    - device type
   * @param {object}  config    - configGDPMedio object
   * @param {integer} dynamicId - dynamicId(infinite-scroll)
   */
  init: function init(config) {
    _gatewaysPromises = [];
    // NOTE: load promises of active gateways
    _loadActivesGateways.call(_gatewaysPromises, config);

    // NOTE: when all promises are resolved, rejected or timeout reached, resolve the HB-Promise
    return RSVP.all(_gatewaysPromises).then(function () {
      (0, _logger.showLog)('HBManager:init:All gateways have finished');
      _application2.default.promised(_constants.HEADER_BIDDING_READY, true);
    }).catch(function (reason) {
      (0, _logger.showError)('HBManager:init:Error in gateways', reason);
      _application2.default.promised(_constants.HEADER_BIDDING_READY, false);
    });
  },

  /**
   * Set targeting to DFP request
   */
  setTargetings: function setTargetings() {
    (0, _logger.showLog)('HBManager:setTargetings:Setting targetings for each added gateways');
    _gatewaysAdded.forEach(function (gateway) {
      gateway.setTargetings();
    });
  },

  /**
   * Check if there are gateways actives
   */
  isActive: function isActive() {
    return _gatewaysPromises.length;
  }
});

/* Private */

/**
 * Load active gateways by config
 * @param {object} configGDPMedio
 */

function _loadActivesGateways(config) {
  var _this = this;

  _gatewaysAdded = [];
  GATEWAYS.forEach(function (gateway) {
    if (gateway.isActive(config)) {
      (0, _logger.showLog)('HBManager:loadActivesGateways:Add promise', gateway.NAME);
      _gatewaysAdded.push(gateway);
      _this.push(gateway.getLoadPromise(config));
    }
  });
}

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = __webpack_require__(2);

var _application2 = _interopRequireDefault(_application);

var _logger = __webpack_require__(1);

var _constants = __webpack_require__(0);

__webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: 'apstag' is the global variable that Amazon searches for
var _adserverRequestResponse = false;

var REASONS = {
  ERROR_LOAD_LIBRARY: 'ERROR_LOAD_LIBRARY',
  TIMEOUT_REACHED_GLOBAL: 'TIMEOUT_REACHED_GLOBAL',
  TIMEOUT_REACHED_FETCH_BIDS: 'TIMEOUT_REACHED_FETCH_BIDS',
  ERROR_INIT_CONFIG: 'ERROR_INIT_CONFIG'
};
var _window = window,
    RSVP = _window.RSVP;

var NAME = 'AMAZON';

exports.default = Object.preventExtensions({
  NAME: NAME,
  isActive: function isActive(_ref) {
    var hbAmazon = _ref.hbAmazon;

    if (hbAmazon) {
      (0, _logger.showLog)('Amazon:Is active');
    } else {
      (0, _logger.showLog)('Amazon:Is NOT active');
    }
    return hbAmazon;
  },

  /**
   * Launch amazon behaviour
   * @param  {object}  adUnits - adUnits config
   * @param  {object}  biddersConfig
   * @param  {integer} timeout
   * @return {Promise}
   */
  getLoadPromise: function getLoadPromise(_ref2) {
    var hbAmazon = _ref2.hbAmazon;

    return new RSVP.Promise(function (resolve, reject) {
      var timeout = hbAmazon.timeout || _constants.DEFAULT_AMAZON_LOAD_TIMEOUT;

      _adserverRequestResponse = false;
      _loadLibrary().then(function () {
        (0, _logger.showLog)('Amazon:getLoadPromise:Library loaded');
        return _setConfig();
      }).then(function () {
        (0, _logger.showLog)('Amazon:getLoadPromise:apstag is loaded');
        return _fetchBid(hbAmazon);
      }).then(function () {
        (0, _logger.showLog)('Amazon:getLoadPromise:Bids fetched');
        resolve(true);
      }).catch(function (reason) {
        reject(reason);
      });

      setTimeout(function () {
        if (!_adserverRequestResponse) {
          (0, _logger.showWarn)('Amazon:getLoadPromise:Timeout reached', timeout);
          reject(REASONS.TIMEOUT_REACHED_GLOBAL);
        }
      }, timeout);
    }).catch(function (reason) {
      switch (reason) {
        case REASONS.TIMEOUT_REACHED_GLOBAL:
          (0, _logger.showLog)('Amazon:getLoadPromise:TIMEOUT reached global');
          break;
        case REASONS.TIMEOUT_REACHED_FETCH_BIDS:
          (0, _logger.showLog)('Amazon:getLoadPromise:TIMEOUT reached in _fetchBid');
          break;
        case REASONS.ERROR_LOAD_LIBRARY:
          (0, _logger.showError)('Amazon:getLoadPromise:Error loading library');
          break;
        case REASONS.ERROR_INIT_CONFIG:
          (0, _logger.showError)('Amazon:getLoadPromise:Error on init config');
          break;
        default:
          (0, _logger.showError)('Amazon:getLoadPromise:Error in Amazon process', reason);
      }
      return false;
    });
  },


  /**
   * Force setTargeting
   */
  setTargetings: function setTargetings() {
    if (_adserverRequestResponse) {
      window.customcmd.push(function () {
        window.apstag.setDisplayBids();
        (0, _logger.showLog)('Amazon:setTargetings:Targetings added');
      });
    } else {
      (0, _logger.showLog)('Amazon:setTargetings:Targetings NOT added because no response from bidders');
    }
  }
});

/* Private */

/**
 * Load Amazon library
 * @return {Promise}
 */

function _loadLibrary() {
  (0, _logger.showLog)('Amazon:loadLibrary:Loading library');
  return _application2.default.load(_constants.AMAZON_URL).catch(function (reason) {
    (0, _logger.showError)('Amazon:loadLibrary:Error', reason);
    return RSVP.reject(REASONS.ERROR_LOAD_LIBRARY);
  });
}

/**
 * Set apstag init config
 */
function _setConfig() {
  return new RSVP.Promise(function (resolve, reject) {
    // NOTE: set custom config object
    (0, _logger.showLog)('Amazon:setConfig:Show Amazon config', _constants.AMAZON_CONFIG);
    try {
      window.apstag.init(_constants.AMAZON_CONFIG, function () {
        resolve();
      });
    } catch (error) {
      (0, _logger.showError)('Amazon:setConfig:Error', error);
      reject(REASONS.ERROR_INIT_CONFIG);
    }
  });
}

/**
 * Add slots config and make Amazon call
 * @param {object}  config - hbAmazon config from configGDPMedio
 */
function _fetchBid(config) {
  var bidConfig;

  bidConfig = {
    slots: config.slots,
    timeout: config.timeout || _constants.DEFAULT_AMAZON_LOAD_TIMEOUT
  };

  return new RSVP.Promise(function (resolve, reject) {
    (0, _logger.showLog)('Amazon:fetchBid:Add Slots', bidConfig.slots);
    (0, _logger.showLog)('Amazon:fetchBid:Request Amazon');
    window.apstag.fetchBids(bidConfig, function (bids) {
      (0, _logger.showLog)('Amazon:fetchBid:Response from Amazon', bids);
      // NOTE: When there are no bids returned, the bids array will be empty
      if (Object.keys(bids).length === 0) {
        reject(REASONS.TIMEOUT_REACHED_FETCH_BIDS);
        return;
      }
      (0, _logger.showLog)('Amazon:fetchBid:Targetings keys', window.apstag.targetingKeys());
      _adserverRequestResponse = true;
      resolve();
    });
  });
}

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// NOTE: function to queue the apstag calls before the library load, the original load the library too(https://ams.amazon.com/webpublisher/docs/help/web-integration-documentation/integration-guide/javascript-guide/display.html)
(function IIFE(apstagGlobalName, root) {
  if (root[apstagGlobalName]) return;
  function queue(c, r) {
    root[apstagGlobalName]._Q.push([c, r]);
  }
  root[apstagGlobalName] = {
    init: function init() {
      queue('i', arguments);
    },
    fetchBids: function fetchBids() {
      queue('f', arguments);
    },
    setDisplayBids: function setDisplayBids() {},
    targetingKeys: function targetingKeys() {
      return [];
    },
    _Q: []
  };
})('apstag', window);

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _application = __webpack_require__(2);

var _application2 = _interopRequireDefault(_application);

var _logger = __webpack_require__(1);

var _constants = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REASONS = {
  EMPTY_ADUNITS: 'EMPTY_ADUNITS',
  ERROR_LOAD_LIBRARY: 'ERROR_LOAD_LIBRARY',
  TIMEOUT_REACHED_GLOBAL: 'TIMEOUT_REACHED_GLOBAL',
  TIMEOUT_REACHED_FETCH_BIDS: 'TIMEOUT_REACHED_FETCH_BIDS'
};
var _window = window,
    RSVP = _window.RSVP;

var NAME = 'PREBID';

var _adserverRequestResponse = false;

// NOTE: This is the global variable that Prebid searches for
window.pbjs = window.pbjs || {};
window.pbjs.que = window.pbjs.que || [];

exports.default = Object.preventExtensions({
  NAME: NAME,
  isActive: function isActive(_ref) {
    var hbPrebid = _ref.hbPrebid;

    if (hbPrebid) {
      (0, _logger.showLog)('Prebid:Is active');
    } else {
      (0, _logger.showLog)('Prebid:Is NOT active');
    }
    return hbPrebid;
  },

  /**
   * Launch prebid behaviour
   * @param  {object}  adUnits - adUnits config
   * @param  {object}  biddersConfig
   * @param  {integer} timeout
   * @return {Promise}
   */
  getLoadPromise: function getLoadPromise(_ref2) {
    var hbPrebid = _ref2.hbPrebid;

    _adserverRequestResponse = false;
    return new RSVP.Promise(function (resolve, reject) {
      var timeout = hbPrebid.timeout || _constants.DEFAULT_PREBID_LOAD_TIMEOUT;
      _loadLibrary().then(function () {
        (0, _logger.showLog)('Prebid:getLoadPromise:Library loaded');
        _setConfig(hbPrebid);
        return _fetchBid(hbPrebid);
      }).then(function () {
        (0, _logger.showLog)('Prebid:getLoadPromise:Bids fetched');
        resolve(true);
      }).catch(function (reason) {
        reject(reason);
      });

      setTimeout(function () {
        if (!_adserverRequestResponse) {
          (0, _logger.showWarn)('Prebid:getLoadPromise:Timeout reached', timeout);
          reject(REASONS.TIMEOUT_REACHED_GLOBAL);
        }
      }, timeout);
    }).catch(function (reason) {
      switch (reason) {
        case REASONS.TIMEOUT_REACHED_GLOBAL:
          (0, _logger.showLog)('Prebid:getLoadPromise:TIMEOUT reached global');
          break;
        case REASONS.TIMEOUT_REACHED_FETCH_BIDS:
          (0, _logger.showLog)('Prebid:getLoadPromise:TIMEOUT reached in _fetchBid');
          break;
        case REASONS.ERROR_LOAD_LIBRARY:
          (0, _logger.showError)('Prebid:getLoadPromise:Error loading library', reason);
          break;
        case REASONS.EMPTY_ADUNITS:
          (0, _logger.showError)('Prebid:getLoadPromise:There are not adUnits');
          break;
        default:
          (0, _logger.showError)('Prebid:getLoadPromise:Error in Prebid process', reason);
      }
      return false;
    });
  },


  /**
   * Force setTargeting
   */
  setTargetings: function setTargetings() {
    if (_adserverRequestResponse) {
      window.customcmd.push(function () {
        window.pbjs.que.push(function () {
          window.pbjs.setTargetingForGPTAsync();
          (0, _logger.showLog)('Prebid:setTargetings:Targetings added');
        });
      });
    } else {
      (0, _logger.showLog)('Prebid:setTargetings:Targetings NOT added because no response from bidders');
    }
  }
});

/* Private */

/**
 * Load prebid library
 * @return {Promise}
 */

function _loadLibrary() {
  (0, _logger.showLog)('Prebid:loadLibrary:Loading library');
  return _application2.default.load(_constants.PREBID_URL).catch(function (reason) {
    (0, _logger.showError)('Prebid:loadLibrary', reason);
    return RSVP.reject(REASONS.ERROR_LOAD_LIBRARY);
  });
}

function _setConfig(hbPrebid) {
  var biddersConfig, pbjsConfig;

  biddersConfig = hbPrebid.biddersConfig;
  // NOTE: set custom config object
  pbjsConfig = {
    debug: _constants.SHOW_LOGS,
    enableSendAllBids: hbPrebid.enableSendAllBids || true,
    priceGranularity: {
      buckets: [{
        precision: 2, // NOTE: default is 2 if omitted - means 2.123456 rounded to 4 decimal places
        min: 0,
        max: 20,
        increment: 0.01
      }]
    }
  };

  (0, _logger.showLog)('Prebid:setConfig:biddersConfig', biddersConfig);
  window.pbjs.bidderSettings = _fetchBiddersSettings(biddersConfig);
  window.pbjs.setConfig(pbjsConfig);
  (0, _logger.showLog)('Prebid:setConfig:Show Prebid config', window.pbjs.getConfig());
}

/**
 * Add adUnits config and make prebid call
 * @param {object}  config    - hbPrebid config from configGDPMedio
 */
function _fetchBid(hbPrebid) {
  var adUnits, timeout;

  adUnits = hbPrebid.adUnits;
  timeout = hbPrebid.timeout || _constants.DEFAULT_PREBID_LOAD_TIMEOUT;

  return new RSVP.Promise(function (resolve, reject) {
    if (!adUnits.length) {
      (0, _logger.showLog)('Prebid:fetchBid:There are not adUnits');
      reject(REASONS.EMPTY_ADUNITS);
      return;
    }
    window.pbjs.que.push(function () {
      (0, _logger.showLog)('Prebid:fetchBid:Add adUnits', adUnits);
      window.pbjs.addAdUnits(adUnits);
      (0, _logger.showLog)('Prebid:fetchBid:Request Prebid');
      window.pbjs.requestBids({
        timeout: timeout,
        bidsBackHandler: function bidsBackHandler(biddersResponse) {
          (0, _logger.showLog)('Prebid:fetchBid:Response from Prebid', biddersResponse);
          if (Object.keys(biddersResponse).length === 0) {
            reject(REASONS.TIMEOUT_REACHED_FETCH_BIDS);
            return;
          }
          (0, _logger.showLog)('Prebid:fetchBid:Targetings', window.pbjs.getAdserverTargeting());
          _adserverRequestResponse = true;
          resolve();
        }
      });
    });
  });
}

/**
 * Build bidders settings from config
 * @param  {object} biddersConfig - biddersConfig from configGDPMedio.hbPrebid
 * @return {object} bidderSettings
 */
function _fetchBiddersSettings(biddersConfig) {
  var bidderSettings = {};

  Object.keys(biddersConfig).forEach(function (bidderName) {
    bidderSettings[bidderName] = {
      bidCpmAdjustment: function bidCpmAdjustment(bidCpm, bid) {
        var percent;

        percent = 1 - ('percent' in biddersConfig[bidderName] ? biddersConfig[bidderName].percent / 100 : 0);
        // NOTE: adjust the bid in real time before the auction takes place
        (0, _logger.showLog)('Prebid:fetchBiddersSettings:bidCpmAdjustment Bidder is:', bid.bidderCode, 'with percent:', percent);
        // NOTE: return bidCpm * .85; Ex.: rest 15% to the gross price
        return bidCpm * percent;
      }
    };
  });

  return bidderSettings;
}

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(0);

var _logger = __webpack_require__(1);

exports.default = Object.preventExtensions({
  processConfig: function processConfig(configManager) {
    (0, _logger.showLog)('HBConfigManager:processConfig:Process HB config');
    _processPrebidConfig(configManager);
    _processAmazonConfig(configManager);
  }
});

/**
 * Process Prebid HB config to set dynamicId
 * @param {object} configManager
 */

function _processPrebidConfig(configManager) {
  var property, adUnits, newConfig, biddersDisabled;
  var headerBidding = configManager.configGDPMedio.headerBidding;


  (0, _logger.showLog)('HBConfigManager:processPrebidConfig:Process Prebid config');

  if (!headerBidding) {
    (0, _logger.showLog)('HBConfigManager:processPrebidConfig:There are not Prebid configuration');
    configManager.configGDPMedio.hbPrebid = null;
    return;
  }

  property = 'adUnits_' + configManager.deviceType;
  if (!(property in headerBidding) || !headerBidding[property].length) {
    (0, _logger.showLog)('HBConfigManager:processPrebidConfig:There are not bidders to device type', configManager.deviceType);
    configManager.configGDPMedio.hbPrebid = null;
    return;
  }

  // NOTE: 'disabled' key has the disabled bidders separated by comma
  biddersDisabled = [];
  if ('disabled' in headerBidding.biddersConfig) {
    biddersDisabled = headerBidding.biddersConfig.disabled.map(function (current) {
      return current.trim();
    });
  }

  adUnits = [];
  headerBidding[property].forEach(function (current) {
    var position,
        newBids = [];

    position = current.code.replace(new RegExp('(' + _constants.OLD_PREFIX + '|' + _constants.NEW_SUFFIX + ')', 'g'), '');
    if (!configManager.existePosEnConfigGDPMedio(position)) {
      (0, _logger.showWarn)('HBConfigManager:processPrebidConfig:Position ' + position + ' does not exists in configGDPMedio');
      return;
    }
    if (!configManager.isActive({ position: position })) {
      (0, _logger.showWarn)('HBConfigManager:processPrebidConfig:Position ' + position + ' is not active');
      return;
    }

    current.code += configManager.dynamicId ? '-' + configManager.dynamicId : '';

    if (biddersDisabled.length) {
      current.bids.forEach(function (bid) {
        if (biddersDisabled.indexOf(bid.bidder) < 0) {
          newBids.push(bid);
        }
      });
    } else {
      newBids = current.bids;
    }

    if (!newBids.length) {
      (0, _logger.showWarn)('HBConfigManager:processPrebidConfig:Remove adUnit ' + current.code + ' because all bidders are disabled');
      return;
    }

    current.bids = newBids;
    adUnits.push(current);
  });

  newConfig = {
    adUnits: adUnits,
    biddersConfig: headerBidding.biddersConfig,
    enableSendAllBids: headerBidding.enableSendAllBids,
    timeout: headerBidding.timeout || _constants.DEFAULT_PREBID_LOAD_TIMEOUT
  };

  delete configManager.configGDPMedio.headerBidding;
  configManager.configGDPMedio.hbPrebid = newConfig;
}

/**
 * Process Amazon HB config to set dynamicId and slotName
 * @param  {object} configManager
 */
function _processAmazonConfig(configManager) {
  var property, slots, newConfig;
  var hbAmazon = configManager.configGDPMedio.hbAmazon;


  if (!hbAmazon) {
    (0, _logger.showLog)('HBConfigManager:processAmazonConfig:There are not Amazon configuration');
    configManager.configGDPMedio.hbAmazon = null;
    return;
  }

  property = 'slots_' + configManager.deviceType;
  if (!(property in hbAmazon) || !hbAmazon[property].length) {
    (0, _logger.showLog)('HBConfigManager:processAmazonConfig:There are not slots to device type', configManager.deviceType);
    configManager.configGDPMedio.hbAmazon = null;
    return;
  }

  slots = [];
  hbAmazon[property].forEach(function (current) {
    var position;

    position = current.slotID.replace(new RegExp('(' + _constants.OLD_PREFIX + '|' + _constants.NEW_SUFFIX + ')', 'g'), '');
    if (!configManager.existePosEnConfigGDPMedio(position)) {
      (0, _logger.showWarn)('HBConfigManager:processAmazonConfig:Position ' + position + ' does not exists in configGDPMedio');
      return;
    }
    if (!configManager.isActive({ position: position })) {
      (0, _logger.showWarn)('HBConfigManager:processAmazonConfig:Position ' + position + ' is not active');
      return;
    }

    current.slotName = _getAmazonSlotName(configManager, position);
    current.slotID += configManager.dynamicId ? '-' + configManager.dynamicId : '';
    slots.push(current);
  });

  newConfig = {
    slots: slots,
    timeout: hbAmazon.timeout || _constants.DEFAULT_AMAZON_LOAD_TIMEOUT
  };

  configManager.configGDPMedio.hbAmazon = newConfig;
}

function _getAmazonSlotName(configManager, position) {
  var params;

  var container$ = $('[data-voc-vam-position = \'' + position + '\']', configManager.context$);
  if (container$.length) {
    params = configManager.normalizaParams(container$);
  } else {
    params = configManager.normalizaParams({ position: position });
  }

  return configManager.getOasSitepage(params);
}

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = {"name":"vam","version":"3.8.1","description":"","main":"src/index.js","scripts":{"test":"./node_modules/.bin/nyc ./node_modules/.bin/mocha-webpack tests/index.js --require jsdom-global/register --webpack-config webpack.test.js","tdd":"./node_modules/.bin/mocha-webpack tests/index.js --require jsdom-global/register --webpack-config webpack.test.js --watch","start":"./node_modules/.bin/webpack-dev-server --open --config webpack.dev.js","build":"./node_modules/.bin/webpack --optimize-minimize --config webpack.prod.js","prebid":"cd ./node_modules/prebid.js/ && npm install && \"./node_modules/.bin/gulp\" build --modules=../../src/header-bidding/prebid-modules.json && cd ../.."},"contributors":["Jose Manuel Ortega <jmortega@vocento.com>","Ernesto V. <evladpereda@ces.vocento.com>","Iván Pérez <ivanperez@vocento.com>"],"license":"SEE LICENSE IN LICENSE.md","devDependencies":{"babel-core":"^6.26.0","babel-eslint":"^8.0.1","babel-loader":"^7.1.2","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-polyfill":"^6.16.0","babel-preset-env":"^1.6.1","chai":"^4.1.2","chalk":"^1.1.3","clean-webpack-plugin":"^0.1.17","copy-webpack-plugin":"^4.3.1","css-loader":"^0.28.4","eslint":"^4.7.2","eslint-config-airbnb-base":"^12.0.1","eslint-plugin-import":"^2.7.0","extract-text-webpack-plugin":"^1.0.1","file-loader":"^1.1.6","html-loader":"^0.5.5","html-webpack-plugin":"^2.30.1","json-loader":"^0.5.7","mocha":"^4.0.1","mocha-loader":"^1.0.0","mocha-phantomjs":"^4.1.0","mocha-webpack":"^1.0.1","nyc":"^11.4.1","style-loader":"^0.18.2","webpack":"^3.10.0","webpack-dev-server":"^2.9.7","webpack-merge":"^4.1.1","webpack-shell-plugin":"^0.5.0"},"dependencies":{"jquery-inview":"^1.1.2","js-cookie":"^2.1.4","prebid.js":"^0.34.1","rijndael-js":"^1.0.0","rsvp":"^3.5.0"}}

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isEmpty = isEmpty;
exports.getParameterByName = getParameterByName;
exports.load = load;
exports.cargaLibreriaGPT = cargaLibreriaGPT;
exports.extend = extend;

var _logger = __webpack_require__(1);

var _constants = __webpack_require__(0);

var _files = {};

/**
 * Check if a object is empty or is undefined. Not be used for arrays or strings
 * @param  {mixed} value
 * @return {boolean}
 */
function isEmpty(value) {
  // OK
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' && typeof value !== 'undefined') {
    return false;
  }

  return true;
}

/**
 * Get a URL param value
 * @param {string} paramName
 * @param {string} url
 */
function getParameterByName(paramName) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

  var regExp, results;

  // NOTE: replace the '[element]' with '\[element\]' using '\\$&'
  paramName = paramName.replace(/[[\]]/g, '\\$&');
  regExp = new RegExp('[?&]' + paramName + '(=([^&#]+)|&|#|$)');
  results = regExp.exec(url);

  if (!results) return '';
  if (!results[2]) return '';

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function load(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var promise, file, key;

  key = url.split('?').shift();
  if (Object.hasOwnProperty.call(_files, key)) {
    return _files[key];
  }

  options.type = options.type || 'script';

  file = document.createElement(options.type);
  switch (options.type) {
    case 'link':
      file.type = 'text/css';
      file.rel = 'stylesheet';
      file.href = url;
      break;
    case 'script':
    default:
      file.type = 'text/javascript';
      file.src = url;
      file.async = true;
      options.text && (file.text = options.text);
      break;
  }

  promise = new window.RSVP.Promise(function (resolve, reject) {
    file.onload = function () {
      return resolve(file);
    };
    file.onerror = reject;

    document.head.appendChild(file);
  });

  _files[key] = promise;
  return promise;
}

/**
 * Carga del JS para la publicidad de Google
 */
function cargaLibreriaGPT() {
  var gads, useSSL, node;
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];
  window.customcmd = window.customcmd || [];
  try {
    if ($('script[src*=\'' + _constants.GPT_URL + '\']').length === 0) {
      gads = document.createElement('script');
      gads.async = true;
      gads.type = 'text/javascript';
      useSSL = document.location.protocol === 'https:';
      gads.src = (useSSL ? 'https:' : 'http:') + ('//' + _constants.GPT_URL);
      node = document.getElementsByTagName('script')[0];
      node.parentNode.insertBefore(gads, node);
      window.googletag.cmd.push(function () {
        var func;
        (0, _logger.showLog)('First function', window.customcmd.length);
        while (window.customcmd.length) {
          func = window.customcmd.splice(0, 1)[0];
          window.googletag.cmd.push(func);
        }
        (0, _logger.showLog)('Finish Pushing to googletag.cmd', window.customcmd.length);
        window.customcmd = window.googletag.cmd;
      });
    }
  } catch (err) {
    (0, _logger.showError)('Utils:cargaLibreriaGPT:Error loading GPT library');
  }
}

function extend() {
  var args = arguments;

  Object.values(args).forEach(function (argument, pos) {
    pos !== 0 && Object.keys(argument).forEach(function (key) {
      args[0][key] = argument[key];
    });
  });

  return args[0];
}

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(21);


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extend = extend;
function extend(destination, source) {
  Object.keys(source).forEach(function (key) {
    destination[key] = source[key];
  });
}

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _configManager = __webpack_require__(33);

var _configManager2 = _interopRequireDefault(_configManager);

var _application = __webpack_require__(2);

var _application2 = _interopRequireDefault(_application);

var _utils = __webpack_require__(5);

var _logger = __webpack_require__(1);

var _constants = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URL_PARAM_ALL = 'all';

var _dynamicId = -1,
    _prevEncryptedCode = '',
    _prevUnencryptedCode = '';

var ConfigManager = function () {
  function ConfigManager(configGDPMedio, configGDP) {
    _classCallCheck(this, ConfigManager);

    _prevEncryptedCode = '';
    _prevUnencryptedCode = '';
    this.configGDPMedio = (0, _utils.extend)({}, configGDPMedio);
    this.configGDP = (0, _utils.extend)({}, configGDP);
    this.deviceType = _getTipoDispositivo.call(this);
    this.pageType = _getTipoPagina.call(this);
    this.dynamicId = ++_dynamicId;
    this.context$ = null;
    this.isResponsiveMedia = _isResponsiveMedia.call(this);
    this.capturadorDataPreview = '';
    this.valueUserType = _getValueUser();
    this.delayedPositions = _getDelayed.call(this);
    this.prioritizedPositions = _getPrioritized.call(this);
    this.globalTargetings = _getDefineSlotTargetings.call(this);
  }

  /**
   * Process the configGDPMedia
   */


  _createClass(ConfigManager, [{
    key: 'processConfig',
    value: function processConfig() {
      _configManager2.default.processConfig(this);
    }

    /**
     * Check if a position is enabled or disabled
     * @param  {object} params
     * @return {boolean}
     */

  }, {
    key: 'isActive',
    value: function isActive(params) {
      // OK
      var container$, configPosition, configSchedules, currentDate, found;

      // check if all positions or the given in params are actives by URL
      if ('forceActivePosition' in this.configGDPMedio && (this.configGDPMedio.forceActivePosition.indexOf('1') > -1 || this.configGDPMedio.forceActivePosition.indexOf(URL_PARAM_ALL) > -1 || this.configGDPMedio.forceActivePosition.indexOf(params.position) > -1)) {
        return true;
      }

      container$ = $('#' + this.getIdDiv(params));
      configPosition = _application2.default.lookup('posicion_' + this.deviceType + '.' + params.position, this.configGDP);

      // Checking that the config of the device type is added

      if (!(0, _utils.isEmpty)(configPosition)) {
        // Check if the position is active for the page type
        if (configPosition.desactivadoen && configPosition.desactivadoen.length && configPosition.desactivadoen !== '' && configPosition.desactivadoen.indexOf(this.pageType) !== -1) {
          (0, _logger.showLog)('ConfigManager:isActive:Position ' + params.position + ' is not active for the pageType ' + this.pageType);
          container$.trigger(_constants.SLOT_INACTIVE);
          return false;
        }

        // Check if the position has programming
        currentDate = Math.round(+new Date() / 1000);
        found = false;
        configSchedules = _application2.default.lookup('posicion_' + this.deviceType + '.' + params.position + '.programaciones', this.configGDP);
        if (!(0, _utils.isEmpty)(configSchedules) && configSchedules.length) {
          found = configSchedules.some(function (current) {
            var beginDate, endDate;
            beginDate = current.programacion ? current.programacion.fecha_in : 0;
            endDate = current.programacion ? current.programacion.fecha_fin : 0;
            return (beginDate === 0 || currentDate >= beginDate) && (endDate === 0 || currentDate <= endDate);
          });

          if (!found) {
            (0, _logger.showLog)('ConfigManager:isActive:Position ' + params.position + ' is not active for the current date');
            container$.trigger(_constants.SLOT_INACTIVE);
            return false;
          }
        }
      } else {
        (0, _logger.showLog)('ConfigManager:isActive:Position ' + params.position + ' is not active');
        container$.trigger(_constants.SLOT_INACTIVE);
        return false;
      }

      return true;
    }

    /**
     * Generate position identifier
     * FUTURE: Clean this method when all pages(ABC, MH, PPLL) use the
     *         new ADS strategy(PREFIX or SUFIX come from GDP)
     * @param  {object} params
     * @return {string}
     */

  }, {
    key: 'getIdDiv',
    value: function getIdDiv(params) {
      // OK
      var adsId, dynamicId;

      (0, _logger.showLog)('ConfigManager:getIdDiv:Dinamic ID', params.dynamicId, this.dynamicId);
      dynamicId = this.dynamicId ? '-' + this.dynamicId : '';
      if (params.dynamicId !== undefined) {
        dynamicId = params.dynamicId ? '-' + params.dynamicId : '';
      }
      if (params.id && typeof params.id === 'string') {
        (0, _logger.showLog)('ConfigManager:getIdDiv:With Id param', params);
        adsId = params.id.indexOf(_constants.OLD_PREFIX) > -1 ? params.id : '' + _constants.OLD_PREFIX + params.id;
        if (!$('#' + adsId).length) {
          (0, _logger.showLog)('ConfigManager:getIdDiv:With Id param. Not found ID', adsId);
          adsId = params.id.indexOf(_constants.NEW_SUFFIX) > -1 ? params.id : '' + params.id + _constants.NEW_SUFFIX;
        }
        adsId += adsId.endsWith(dynamicId) ? '' : dynamicId;
        (0, _logger.showLog)('ConfigManager:getIdDiv:With Id param. Id calculated', adsId);
      } else {
        (0, _logger.showLog)('ConfigManager:getIdDiv:No Id param', params);
        adsId = '' + _constants.OLD_PREFIX + params.position;
        if (!$('#' + adsId).length) {
          (0, _logger.showLog)('ConfigManager:getIdDiv:No Id param. Not found ID', adsId);
          adsId = '' + params.position + _constants.NEW_SUFFIX + dynamicId;
        }
        (0, _logger.showLog)('ConfigManager:getIdDiv:No Id param. Id calculated', adsId);
      }

      return adsId;
    }

    /**
     * Check if position exist in media config
     * @param   {string} position
     * @param   {string} deviceType
     * @returns {boolean} - TRUE if exist, FALSE otherwise
     */

  }, {
    key: 'existePosEnConfigGDPMedio',
    value: function existePosEnConfigGDPMedio(position) {
      var deviceType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.deviceType;
      // OK
      var idAds;

      if (!(0, _utils.isEmpty)(_application2.default.lookup('posicion_' + deviceType + '.' + position, this.configGDPMedio))) {
        return true;
      }
      // If position do not exist, hide the container DIV
      idAds = this.getIdDiv({ position: position });
      $('#' + idAds).length && $('#' + idAds).hide();

      return false;
    }

    /**
     * Normalize the position's parameters
     */

  }, {
    key: 'normalizaParams',
    value: function normalizaParams(data) {
      // OK
      var params, outOfPage, idAds, offset;

      params = {};
      // jQuery object or JSON object
      if (data instanceof $) {
        (0, _utils.extend)(params, _constants.DEFAULTS, {
          position: data.data('voc-vam-position') || null,
          serverType: data.data('voc-vam-servertype') || _getServerType.call(this, params.position),
          hideNoAds: data.data('voc-vam-hidenoads'),
          outOfPage: data.data('voc-vam-outofpage'),
          defineSlot: data.data('voc-vam-defineslot') || _getDefineSlotParam.call(this),
          refresh: data.data('voc-vam-refresh'),
          responsive: data.data('voc-vam-responsive'),
          pre_callback: data.data('voc-vam-precallback') || '',
          pre_event: data.data('voc-vam-preevent') || '',
          post_callback: data.data('voc-vam-postcallback') || '',
          post_event: data.data('voc-vam-postevent') || '',
          oas: data.data('voc-vam-oas') || '',
          tags: data.data('voc-vam-tags'),
          dynamicId: this.dynamicId
        });
      } else {
        (0, _utils.extend)(params, _constants.DEFAULTS, {
          position: data.position || null,
          id: data.id || null,
          serverType: data.serverType || _getServerType.call(this, params.position),
          hideNoAds: data.hideNoAds,
          outOfPage: data.outOfPage,
          defineSlot: data.defineSlot || _getDefineSlotParam.call(this),
          refresh: data.refresh,
          responsive: data.responsive,
          pre_callback: data.pre_callback || '',
          pre_event: data.pre_event || '',
          post_callback: data.post_callback || '',
          post_event: data.post_event || '',
          oas: data.oas || '',
          tags: data.tags,
          dynamicId: data.dynamicId || this.dynamicId
        });
      }

      // if some required parameter is missing, return null
      if (params.position === null) {
        (0, _logger.showWarn)('ConfigManager:normalizaParams:Position param is required', data);
        return null;
      }

      if (!this.existePosEnConfigGDPMedio(params.position)) {
        (0, _logger.showWarn)('ConfigManager:normalizaParams:Position ' + params.position + ' does not exists in configGDPMedio');
        return null;
      }

      // OutOfPage param
      if (typeof params.outOfPage !== 'boolean') {
        outOfPage = _application2.default.lookup('posicion_' + this.deviceType + '.' + params.position + '.outofpage', this.configGDPMedio);
        params.outOfPage = (0, _utils.isEmpty)(outOfPage) || typeof outOfPage !== 'boolean' ? false : outOfPage;
      }

      // ads container DIV
      idAds = this.getIdDiv(params);
      if (!$('#' + idAds).length && $('[data-voc-vam-position = \'' + params.position + '\']', this.context$).length && !$('[data-voc-vam-position = \'' + params.position + '\']', this.context$).attr('id')) {
        $('[data-voc-vam-position = \'' + params.position + '\']', this.context$).attr('id', idAds);
      }
      params.id = idAds;

      // global targetings
      if (!params.tags) {
        params.tags = _application2.default.lookup('posicion_' + this.deviceType + '.' + params.position + '.targetings', this.configGDPMedio) || {};
      }

      // offset
      offset = _application2.default.lookup('posicion_' + this.deviceType + '.' + params.position + '.offset', this.configGDP);
      if (!(0, _utils.isEmpty)(offset)) {
        $('#' + params.id).attr('data-offset', offset);
        (0, _logger.showLog)('ConfigManager:normalizaParams:Offset ' + offset + ' configurer for position: ' + params.position);
      }

      // build the responsive parameter if it doesn't come in the data
      if (!params.outOfPage && !params.responsive && this.isResponsiveMedia) {
        params.responsive = _getResponsiveParam.call(this, params);
      }

      return params;
    }

    /**
     * Get OAS value from config
     * FUTURE: create final OAS config on GDP
     * @return string
     */

  }, {
    key: 'getOasSitepage',
    value: function getOasSitepage() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var oasSitepage, decryptedURL, legacyAdUnit, regExp, result, macroEdition, edition;

      if (params.oas) {
        oasSitepage = params.oas.trim();
      } else {
        oasSitepage = _application2.default.lookup('OAS.' + this.deviceType + '.' + this.pageType, this.configGDP);
        oasSitepage = (0, _utils.isEmpty)(oasSitepage) ? '' : oasSitepage.trim();
      }

      // check if adUnit is forced by URL
      try {
        decryptedURL = ConfigManager.decryptedURL();
        if (window.location.href.indexOf('vam_adunit=') > -1 || window.location.href.indexOf('adunit=') > -1 || decryptedURL !== '') {
          legacyAdUnit = window.location.href.indexOf('vam_adunit=') > -1 ? 'vam_adunit' : 'adunit';
          regExp = new RegExp('(\\?|&)' + legacyAdUnit + '=([^?&]+)');
          result = decryptedURL !== '' ? regExp.exec(decryptedURL) : regExp.exec(window.location.href);

          if (result) {
            oasSitepage = result[2].indexOf('/' + _constants.GPT_ID_VOCENTO + '/') > -1 ? result[2] : '/' + _constants.GPT_ID_VOCENTO + '/' + result[2];
          }
        }
      } catch (err) {
        (0, _logger.showError)('ConfigManager:getOasSitepage:Error checking adUnit', err);
      }

      // check macro edition
      try {
        regExp = /{(\/)?edicion(\/)?}/;
        macroEdition = regExp.exec(oasSitepage);
        if (macroEdition) {
          edition = _getEdition();
          if (macroEdition[0].startsWith('{/') && edition) edition = '/' + edition;
          if (macroEdition[0].endsWith('/}') && edition) edition += '/';

          oasSitepage = oasSitepage.replace(macroEdition[0], edition);
        }
      } catch (err) {
        (0, _logger.showError)('ConfigManager:getOasSitepage:Error checking edition', err);
      }

      // Guardamos el valor del adunit calculado por si no lo esta
      if (typeof this.configGDP.OAS.adunit === 'undefined') this.configGDP.OAS.adunit = oasSitepage;

      return oasSitepage;
    }

    /**
     * Calculate the sizes for a given position
     * FUTURE: move config to GDP
     * @param  {string} position
     * @param  {string} deviceType - default is _deviceType
     * @return {object}
     */

  }, {
    key: 'getSizesGoogle',
    value: function getSizesGoogle(position) {
      var deviceType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.deviceType;
      // OK
      var configSize, size, defineSlot;

      configSize = _application2.default.lookup('posicion_' + deviceType + '.' + position + '.dimensiones', this.configGDPMedio);

      size = !(0, _utils.isEmpty)(configSize) ? configSize : '[]';
      defineSlot = _getDefineSlotParam.call(this);

      if (size.indexOf('[fluid]') > -1) {
        if (!defineSlot) return ['fluid'];

        size = size.replace('[fluid]', '\'fluid\'');
      }

      return defineSlot ? size : JSON.parse(size);
    }

    /**
     * Detect forced config by URL.
     * Support params:
     *   vam_adunit
     *   vam_cmvkey
     *   vam_debug
     *   vam_enable_single_request
     *   vam_enable_sync_rendering
     *   vam_enable_krux
     *   vam_force_positions
     *   vam_info_slot
     */

  }, {
    key: 'checkConfigFromURL',
    value: function checkConfigFromURL() {
      var legacyCode, code, prebidDisabledBidders;
      if (typeof window.location === 'undefined') return;

      // Disable Prebid
      if ('headerBidding' in this.configGDPMedio && window.location.href.indexOf('vam_prebid_disabled=') > -1) {
        prebidDisabledBidders = (0, _utils.getParameterByName)('vam_prebid_disabled', window.location.href).split(',');
        this.configGDPMedio.headerBidding.biddersConfig.disabled = prebidDisabledBidders;
        if (prebidDisabledBidders.indexOf(URL_PARAM_ALL) > -1) {
          this.configGDPMedio.headerBidding = null;
        }
      }

      // Disable HB Amazon
      if ('hbAmazon' in this.configGDPMedio) {
        this.configGDPMedio.hbAmazon = window.location.href.indexOf('vam_amazon_disabled=1') > -1 || window.location.href.indexOf('gdp_enableAmazonAds=0') > -1 || !this.configGDPMedio.enableAmazonAds ? false : this.configGDPMedio.hbAmazon;
      }

      // Single Request
      this.configGDPMedio.singleRequest = window.location.href.indexOf('vam_single_request=1') > -1 || window.location.href.indexOf('gdp_singleRequest=1') > -1 || this.configGDPMedio.singleRequest;

      // SyncRendering
      this.configGDPMedio.syncRendering = window.location.href.indexOf('vam_sync_rendering=1') > -1 || window.location.href.indexOf('gdp_syncRendering=1') > -1 || this.configGDPMedio.syncRendering;

      // Krux
      this.configGDPMedio.enableKrux = window.location.href.indexOf('vam_krux=1') > -1 || window.location.href.indexOf('gdp_enableKrux=1') > -1 || this.configGDPMedio.enableKrux;

      // Force active position
      this.configGDPMedio.forceActivePosition = window.location.href.indexOf('vam_force_positions=') > -1 ? (0, _utils.getParameterByName)('vam_force_positions', window.location.href).split(',') : (0, _utils.getParameterByName)('gdp_forceActivePosition', window.location.href).split(',');

      // InfoSlot
      this.configGDPMedio.infoSlot = window.location.href.indexOf('vam_info_slot=1') > -1 || window.location.href.indexOf('gdp_infoSlot=1') > -1;
      if (this.configGDPMedio.infoSlot) {
        (0, _utils.load)(_constants.VAM_CSS_URL, {
          type: 'link'
        }).then(function () {
          (0, _logger.showLog)('ConfigManager:checkConfigFromURL:CSS loaded', _constants.VAM_CSS_URL);
        });
      }

      // Capturador (modo preview)
      this.configGDPMedio.preview = window.location.href.indexOf('vam_preview') > -1 || window.location.href.indexOf('preview') > -1;
      if (this.configGDPMedio.preview) {
        (0, _logger.showLog)('ConfigManager:checkConfigFromURL:Detected capture mode. Call capture SW');
        this.capturadorDataPreview = _capturadorGetPreviewData();

        // En modo capturador no pondremos priorizadas ni retrasadas
        this.configGDP.priorizadas = {};
        this.configGDP.retrasadas = {};
      }

      // Previsualizador
      if (window.location.href.indexOf('vam_code=') > -1 || window.location.href.indexOf('code=') > -1) {
        (0, _logger.showLog)('ConfigManager:checkConfigFromURL:Detected preview mode');
        legacyCode = window.location.href.indexOf('vam_code=') > -1 ? 'vam_code' : 'code';
        code = (0, _utils.getParameterByName)(legacyCode, window.location.href);
        _prevEncryptedCode = decodeURI(code);

        // En modo previsualizador no pondremos priorizadas ni retrasadas
        this.configGDP.priorizadas = {};
        this.configGDP.retrasadas = {};

        if (_prevEncryptedCode !== '') {
          __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 39)).then(function (Rijndael) {
            (0, _logger.showLog)('ConfigManager:Rijndael library is loaded', Rijndael);
            _decriptUrl(Rijndael);
          });
        }
      }
    }

    /**
     * Comprobacion de si existen excepciones para la pagina donde nos encontramos.
     * @return object configGDP
     */

  }, {
    key: 'checkExceptions',
    value: function checkExceptions() {
      var value, unixTime, beginDate, endDate;

      if (this.configGDPMedio.excepciones && Object.keys(this.configGDPMedio.excepciones).length > 0) {
        (0, _logger.showLog)('ConfigManager:checkExceptions:There are configured exceptions');
        Object.keys(this.configGDPMedio.excepciones).forEach(function (key) {
          if (key !== 'priorizadas' && key !== 'retrasadas') {
            if (window.location.pathname === key || window.location.pathname.match(key)) {
              value = this.configGDPMedio.excepciones[key];
              unixTime = Math.round(new Date() / 1000);
              beginDate = value.fecha_in;
              endDate = value.fecha_fin;
              if ((beginDate === 0 || beginDate <= unixTime) && (endDate === 0 || unixTime <= endDate)) {
                this.configGDP = value;
                (0, _logger.showLog)('ConfigManager:checkExceptions:Applying the following exception:"' + key + '"');
              }
            }
          }
        }, this);
      }
    }

    /**
     * Funcion que devuelve la URL desencriptada
     * @returns {string}
     */

  }, {
    key: 'isDelayed',


    /**
     * Funcion que comprueba si una posicion es retrasada
     * FUTURE: listaRetrasadas come in array format from GDP
     */
    value: function isDelayed(position) {
      return this.thereAreDelayedPositions() && this.delayedPositions.indexOf(position) > -1;
    }
  }, {
    key: 'thereAreDelayedPositions',
    value: function thereAreDelayedPositions() {
      return this.delayedPositions.length;
    }

    /**
     * Funcion que comprueba si una posicion es retrasada
     * FUTURE: listaRetrasadas come in array format from GDP
     */

  }, {
    key: 'isPrioritized',
    value: function isPrioritized(position) {
      return this.thereArePrioritizedPositions() && this.prioritizedPositions.indexOf(position) > -1;
    }
  }, {
    key: 'thereArePrioritizedPositions',
    value: function thereArePrioritizedPositions() {
      return this.prioritizedPositions.length;
    }
  }, {
    key: 'removePrioritizedPosition',
    value: function removePrioritizedPosition(position) {
      var index = this.prioritizedPositions.indexOf(position);

      if (index !== -1) {
        this.prioritizedPositions.splice(index, 1);
      }
    }
  }], [{
    key: 'decryptedURL',
    value: function decryptedURL() {
      return _prevUnencryptedCode;
    }
  }]);

  return ConfigManager;
}();

exports.default = ConfigManager;

/* Private */

/**
 * Get the device type depending on the size of the screen
 * @return string
 */

function _getTipoDispositivo() {
  // OK
  var max, min, screenWidth, deviceType;

  deviceType = 'desktop';

  if (!this.configGDPMedio.responsive.esResponsive) {
    if (this.configGDPMedio && this.configGDPMedio.tipoDispositivo) {
      deviceType = this.configGDPMedio.tipoDispositivo;
    }
  } else {
    screenWidth = parseInt(window.innerWidth, 10);

    Object.keys(this.configGDPMedio.responsive).forEach(function (key) {
      var value = this.configGDPMedio.responsive[key];
      if (key !== 'esResponsive' && (value.resolucionMaxima || value.resolucionMinima)) {
        max = value.resolucionMaxima ? value.resolucionMaxima : 999999;
        min = value.resolucionMinima ? value.resolucionMinima : 0;

        if (screenWidth <= max && screenWidth > min) {
          deviceType = key.replace('resolucion', '').toLowerCase();
        }
      }
    }, this);
  }

  return deviceType;
}

/**
 * Look for the medium where we are, from the configuration
 * @return string
 */
function _getMedio() {
  // OK
  return this.configGDPMedio.medio ? this.configGDPMedio.medio : '';
}

/**
 * Get the page type from the URL pattern
 * NOTE: Each medium has its own URL rules so each one has its own function to calculate them
 * FUTURE: set the page type in global namespace on each page
 */
function _getTipoPagina() {
  // OK
  var pageType = 'portada',
      medio = _getMedio.call(this);

  if (['abc', 'lavozdigital', 'abcdesevilla'].indexOf(medio) > -1) {
    pageType = _getTipoPaginaABC();
  } else if (medio === 'mujerhoy') {
    pageType = _getTipoPaginaMujerhoy();
  } else {
    pageType = _getTipoPaginaPortalesLocales();
  }

  return pageType;
}

/**
 * Get the page type from the URL for abc.es, sevilla.abc.es and lavozdigital.es
 * @return {string}
 */
function _getTipoPaginaABC() {
  // OK
  var oldVideosRegExp, videosRegExp, oldGaleryRegExp2, oldGaleryRegExp, galeryRegExp, graphicRegExp, oldNewsRegExp, newsRegExp;

  oldVideosRegExp = /\/videos\/(.*)?\/\d{6}\/\d{2}\/((?!index.html).)*.html/;
  videosRegExp = /_video.html/;
  if (videosRegExp.exec(window.location.pathname) || oldVideosRegExp.exec(window.location.pathname)) return 'video';

  oldGaleryRegExp2 = /\/multimedia\/fotos\/(.*)?\/((?!index.html).)*.html/;
  oldGaleryRegExp = /\/fotos-(.*)?\/\d{8}\/((?!index.html).)*.html/;
  galeryRegExp = /_galeria.html/;
  if (galeryRegExp.exec(window.location.pathname) || oldGaleryRegExp.exec(window.location.pathname) || oldGaleryRegExp2.exec(window.location.pathname)) return 'galeria';

  graphicRegExp = /\/multimedia\/(graficos\/(.)*|infografias)\/((?!index.html).)*.html/;
  if (graphicRegExp.exec(window.location.pathname)) return 'grafico';

  oldNewsRegExp = /\d{8}\/(.*)?((?!index.html).)*.html/;
  newsRegExp = /(_noticia.html|_directo.html)/;
  if (newsRegExp.exec(window.location.pathname) || oldNewsRegExp.exec(window.location.pathname)) return 'noticia';

  return 'portada';
}

/**
 * Get the page type from the URL for mujerhoy.com
 * @return {string}
 */
function _getTipoPaginaMujerhoy() {
  // OK
  var videoRegExp, oldVideoRegExp, videoBlogRegExp, isVideo, galeryRegExp, oldGaleryRegExp, galeryBlogRegExp, isGalery, newsRegExp, newsBlogRegExp, newsRecipesRegExp, isNews;

  videoRegExp = /-vi.html/;
  oldVideoRegExp = /\/videos\/(.*)?\/\d{6}\/\d{2}\/.*-mm.html/;
  videoBlogRegExp = /\/videos\/\d{4}\/\d{2}\/\d{2}\/(.*).html/;
  isVideo = window.location.hostname.indexOf('blogs.') > -1 ? videoBlogRegExp.exec(window.location.pathname) : videoRegExp.exec(window.location.pathname) || oldVideoRegExp.exec(window.location.pathname);
  if (isVideo) return 'video';

  galeryRegExp = /-ga.html/;
  oldGaleryRegExp = /^\/galerias\/(.*)?\d{6}\/\d{2}\/.*-mm.html/;
  galeryBlogRegExp = /\/galerias\/\d{4}\/\d{2}\/\d{2}\/(.*).html/;
  isGalery = window.location.hostname.indexOf('blogs.') > -1 ? galeryBlogRegExp.exec(window.location.pathname) : galeryRegExp.exec(window.location.pathname) || oldGaleryRegExp.exec(window.location.pathname);
  if (isGalery) return 'galeria';

  newsRegExp = /\/\d{6}\/\d{2}\/((?!index.html).)*.html/;
  newsBlogRegExp = /\/\d{4}\/\d{2}\/\d{2}\/((?!index.html).)*.html/;
  newsRecipesRegExp = /\/\d{6}\/((?!index.html).)*.html/;
  if (window.location.hostname.indexOf('blogs.') > -1) {
    isNews = newsBlogRegExp.exec(window.location.pathname);
  } else if (window.location.hostname.indexOf('recetas.') > -1) {
    isNews = newsRecipesRegExp.exec(window.location.pathname);
  } else {
    isNews = newsRegExp.exec(window.location.pathname);
  }
  if (isNews) return 'noticia';

  return 'portada';
}

/**
 * Get the page type from the URL for PPLL
 * @return {string}
 */
function _getTipoPaginaPortalesLocales() {
  // OK
  var videoRegExp, oldVideoRegExp, galeryRegExp, oldGaleryRegExp, newsRegExp, oldNewsRegExp, graphicRegExp, oldGraphicRegExp, videoChatRegExp;

  videoRegExp = /-(vi|virc|vivo)(_amp)?.html/;
  oldVideoRegExp = /^\/videos\/(.*)?\/\d{6}\/\d{2}\/.*-mm.html/;
  if (videoRegExp.exec(window.location.pathname) || oldVideoRegExp.exec(window.location.pathname)) return 'video';

  galeryRegExp = /-(ga|garc|gavo|ft|ftrc|ftvo)(_amp)?.html/;
  oldGaleryRegExp = /^\/fotos\/(.*)?\d{6}\/\d{2}\/.*-mm.html/;
  if (galeryRegExp.exec(window.location.pathname) || oldGaleryRegExp.exec(window.location.pathname)) return 'galeria';

  newsRegExp = /-(nt|ntrc|ntvo)(_amp)?.html/;
  oldNewsRegExp = /\/\d{6}\/\d{2}\/((?!index.html).)*.html/;
  if (newsRegExp.exec(window.location.pathname) || oldNewsRegExp.exec(window.location.pathname)) return 'noticia';

  // NOTA: En PLs, a nivel de publicidad, contemplaremos graficos y videochats como noticias
  graphicRegExp = /-(in|inrc|invo)(_amp)?.html/;
  oldGraphicRegExp = /^\/graficos\/(.*)?\/\d{6}\/\d{2}\/.*-mm.html/;
  videoChatRegExp = /\/videochats\/((?!index.html).)\w+/;
  if (graphicRegExp.exec(window.location.pathname) || oldGraphicRegExp.exec(window.location.pathname) || videoChatRegExp.exec(window.location.pathname)) return 'noticia';

  return 'portada';
}

/**
 * Get defineSlot param from config
 * @return {boolean|undefined}
 */
function _getDefineSlotParam() {
  // OK
  return this.configGDPMedio.defineSlot || undefined;
}

/**
 * Get the serverType of given position
 * @param  {string} position
 * @return {string}
 */
function _getServerType(position) {
  // OK
  var configServerType,
      serverType = 'google';

  configServerType = _application2.default.lookup('posicion_' + this.deviceType + '.' + position + '.tipo', this.configGDPMedio);
  serverType = !(0, _utils.isEmpty)(configServerType) ? configServerType : serverType;

  return serverType;
}

/**
 * Check if is responsive from config
 * @return {boolean}
 */
function _isResponsiveMedia() {
  // OK
  var isResponsive = _application2.default.lookup('responsive.esResponsive', this.configGDPMedio);

  return !(0, _utils.isEmpty)(isResponsive) ? isResponsive : false;
}

/**
 * Build responsive param for the position
 * @return object
 */
function _getResponsiveParam(params) {
  // OK
  if (params.responsive && Array.isArray(params.responsive) && params.responsive.length) {
    return params.responsive;
  }

  /**
   * It doesn't have responsive param but it is
   * responsive medium so we build responsive param with
   * the corresponding resolutions and sizes
   */
  if (this.isResponsiveMedia) {
    return _createResponsive.call(this, params.position);
  }

  return false;
}

/**
 * Build responsive param
 * FUTURE: move config to GDP
 * @return object
 */
function _createResponsive(position) {
  // OK
  var responsive, resolution, minWidth, maxWidth, dimension, googleSize, size;

  (0, _logger.showLog)('ConfigManager:createResponsive:Build responsive for', position);
  responsive = [];
  this.configGDPMedio.dispositivos.forEach(function (device) {
    if (!this.existePosEnConfigGDPMedio(position, device)) return;

    resolution = _application2.default.lookup('responsive.resolucion' + device, this.configGDPMedio);
    if (!(0, _utils.isEmpty)(resolution)) {
      minWidth = resolution.resolucionMinima;
      maxWidth = resolution.resolucionMaxima;

      if (!(0, _utils.isEmpty)(minWidth) && !(0, _utils.isEmpty)(maxWidth) && (minWidth || maxWidth)) {
        dimension = [parseInt(minWidth, 10) || 0, _constants.ALTOS_MINIMOS_DISPOSITIVOS[device]];

        googleSize = this.getSizesGoogle(position, device);
        try {
          if (googleSize && googleSize.indexOf('fluid') > -1) {
            size = 'fluid';
          } else {
            size = JSON.parse(googleSize);
          }
        } catch (e) {
          (0, _logger.showWarn)('ConfigManager:createResponsive:Processing position ' + position + ': ' + e);
          size = googleSize;
        }

        // Insert the dimension mapping ordered from lowest to highest by width
        responsive.push([dimension, size]);
      }
    }
  }, this);
  responsive.sort(function (pair1, pair2) {
    return pair1[0][0] - pair2[0][0];
  });

  responsive.sort(function (pair1, pair2) {
    return pair1[0][0] - pair2[0][0];
  });
  (0, _logger.showLog)('ConfigManager:createResponsive:Build responsive param for position ' + position, responsive);

  return responsive;
}

/**
 * Get edition from config
 */
function _getEdition() {
  // OK
  var editions = _application2.default.lookup(_constants.EDITIONS_NAMESPACE);

  return editions.current || editions.main || '';
}

/**
 * Invoca al Servicio Web del Capturador para obtener las creatividades indicadas en el parametro
 * preview directamente desde DFP.
 */
function _capturadorGetPreviewData() {
  var legacyPreview, url, data;

  legacyPreview = window.location.href.indexOf('vam_preview') > -1 ? 'vam_preview' : 'preview';
  url = _constants.CAPTURADOR_WS + '?id=' + (0, _utils.getParameterByName)(legacyPreview);
  data = '';
  $.ajax({
    url: url,
    type: 'POST',
    async: false,
    success: function success(result) {
      data = result;
    }
  });

  return data;
}

/**
 * Convert Gigya user format to advertising format
 */
function _getValueUser() {
  // OK
  var valueUser,
      arrayUsers = {
    suscriptor: 's',
    trial: 't',
    registrado: 'r',
    anonimo: 'a'
  };

  valueUser = arrayUsers[_application2.default.getUserType()] || 'a';

  return valueUser;
}

function _getDelayed() {
  var delayedPositions;

  delayedPositions = _application2.default.lookup('retrasadas.' + this.deviceType + '.listaPosiciones', this.configGDP);

  if ((0, _utils.isEmpty)(delayedPositions) || !delayedPositions.length) {
    (0, _logger.showLog)('ConfigManager:getDelayed:There are NOT delayed positions');
    return [];
  }

  (0, _logger.showLog)('ConfigManager:getDelayed:There are delayed positions:', delayedPositions);
  delayedPositions = delayedPositions.split(',').filter(function (position) {
    return position.trim();
  });

  return delayedPositions;
}

function _getPrioritized() {
  var prioritizedPositions;

  prioritizedPositions = _application2.default.lookup('priorizadas.' + this.deviceType + '.listaPosiciones', this.configGDP);

  if ((0, _utils.isEmpty)(prioritizedPositions) || !prioritizedPositions.length) {
    (0, _logger.showLog)('ConfigManager:getPrioritized:There are NOT prioritized positions');
    return [];
  }

  (0, _logger.showLog)('ConfigManager:getDelayed:There are prioritized positions:', prioritizedPositions);
  prioritizedPositions = prioritizedPositions.split(',').filter(function (position) {
    return position.trim();
  });

  return prioritizedPositions;
}

/**
 * Decrypt url to get cmvkey param
 * @param {object} mcrypt - Rijndael object
 */
function _decriptUrl(Rijndael) {
  var legacyCmvkey, mcrypt, preparedCode;
  (0, _logger.showLog)('ConfigManager:decriptUrl:Actual prevUnencryptedCode', _prevUnencryptedCode, 'and prevEncryptedCode', _prevEncryptedCode);
  if (_prevUnencryptedCode === '' && _prevEncryptedCode !== '') {
    mcrypt = new Rijndael(_constants.MCRYPT_KEY, 'cbc');
    (0, _logger.showLog)('ConfigManager:decriptUrl:Decrypting', mcrypt);
    preparedCode = atob(_prevEncryptedCode).split('').map(function (value) {
      return value.charCodeAt(0);
    });
    _prevUnencryptedCode = '?' + mcrypt.decrypt(preparedCode, 256, _constants.MCRYPT_KEY);
    (0, _logger.showLog)('ConfigManager:decriptUrl:', _prevUnencryptedCode);
    // NOTE: remove special characters from string
    _prevUnencryptedCode = _prevUnencryptedCode.replace(/[^A-Za-z 0-9.,?""!@#$%^&*()\-_=+;:<>/\\|}{[\]`~]*/g, '');
    if (_prevUnencryptedCode.endsWith('&vam_cmvkey=') || _prevUnencryptedCode.endsWith('&cmvkey=')) {
      legacyCmvkey = _prevUnencryptedCode.endsWith('&vam_cmvkey=') ? '&vam_cmvkey=' : '&cmvkey=';
      _prevUnencryptedCode = _prevUnencryptedCode.replace(legacyCmvkey, '');
    }
    (0, _logger.showLog)('ConfigManager:decriptUrl:String decrypted: ' + _prevUnencryptedCode);
  }

  return _prevUnencryptedCode;
}

/**
 * Funcion que obtiene los tag definidos en los archivos de configuración
 * FUTURE: move config to GDP
 * @return object
 */
function _getDefineSlotTargetings() {
  var medioTargetings, pageTargetings, targetings, defineSlotTargetings;

  medioTargetings = this.configGDPMedio.targetings ? this.configGDPMedio.targetings : {};
  pageTargetings = this.configGDP.targetings ? this.configGDP.targetings : {};
  targetings = {};
  (0, _utils.extend)(targetings, medioTargetings, pageTargetings);

  defineSlotTargetings = '';
  Object.keys(targetings).forEach(function (key) {
    defineSlotTargetings += '.setTargeting("' + key + '", "' + targetings[key] + '")';
  });

  return defineSlotTargetings;
}

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// vam.js